"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDeclineCollectionInvitationResult = exports.parseAcceptCollectionInvitationResult = exports.parseExchangeCollectionInvitationResult = exports.parseCollectionInvitationMutationResult = exports.parseListCollectionPeopleResult = exports.parseCollectionInvitationSummary = exports.parseCollectionMemberSummary = exports.parseDeclineCollectionInvitationRequest = exports.parseAcceptCollectionInvitationRequest = exports.parseExchangeCollectionInvitationRequest = exports.parseRevokeCollectionInvitationRequest = exports.parseResendCollectionInvitationRequest = exports.parseCreateCollectionInvitationRequest = exports.parseListCollectionPeopleRequest = exports.parseUpdateCollectionResult = exports.parseUpdateCollectionRequest = exports.parseCreateCollectionResult = exports.parseCreateCollectionRequest = exports.parseCapacityReconciliationDocument = exports.parseBillingProvisioningConflictDocument = exports.parseBillingProvisioningAuditEventDocument = exports.parseCollectionBulkUpdateRequest = exports.parseCreateCollectionItemRequest = exports.parseCollectionItemCreatePayload = exports.parseOperationClaimDocument = exports.parseCapacityReservationDocument = exports.parseCollectionCapacityStateDocument = exports.parseBillingAccountOwnerIndexDocument = exports.parseBillingAccountDocument = exports.parseCollectionAiCacheEntryDocument = exports.parseCollectionAiPolicyDocument = exports.parseDeleteCollectionResult = exports.parseDeleteCollectionRequest = exports.parseCollectionTransferResult = exports.parseGetCollectionTransferRequest = exports.parseApplyCollectionTransferRequest = exports.parseCancelCollectionTransferRequest = exports.parseAcceptCollectionTransferRequest = exports.parseStartCollectionTransferRequest = exports.parseCollectionAuditEventDocument = exports.parseCollectionTransferDocument = exports.parseCollectionTransferOutcome = exports.parseCollectionInvitationDocument = exports.parseCollectionMembershipDocument = exports.parseCollectionDocument = exports.parseCollectionSession = exports.parseCollectionSummary = exports.parseCursorPage = exports.roundGpsCoordinates = exports.GPS_DECIMAL_PLACES = void 0;
exports.parseResolveCollectionUsernameResult = exports.parseCheckUsernameAvailabilityResult = exports.parseChangeUsernameResult = exports.parseResolveCollectionUsernameRequest = exports.parseCheckUsernameAvailabilityRequest = exports.parseChangeUsernameRequest = exports.parseUsernameClaimDocument = exports.parseUsername = exports.USERNAME_REGEX = exports.parseBillingSummaryResult = exports.parseBillingSummaryRequest = exports.parseAiCreditWalletSummaryResult = exports.parseCreditTransactionHistoryResult = exports.parseAiCreditUsageHistoryResult = exports.parseAiCreditPurchaseHistoryResult = exports.parseAiCreditHistoryRequest = exports.parseCreateAiCreditCheckoutResult = exports.parseCreateAiCreditCheckoutRequest = exports.parseAiCreditPurchaseDocument = exports.parseCreditTransactionDocument = exports.parseAiUsageOperationDocument = exports.parseAiAllowanceDocument = exports.parseCreditBalanceDocument = exports.parseStripeWebhookClaimDocument = exports.parseStripeCustomerMappingDocument = exports.parseCollectionImageDeletionFenceDocument = exports.parseInternalJobTaskRequest = exports.parseInternalJobDocument = exports.parseRunCollectionAiResult = exports.parseRunCollectionAiRequest = exports.parseUpdateCollectionAiPolicyResult = exports.parseUpdateCollectionAiPolicyRequest = exports.parseCollectionAiCapabilityResult = exports.parseCollectionAiCapabilityRequest = exports.parseCollectionCapacityCapabilityResult = exports.parseCollectionCapacityCapabilityRequest = exports.parseCollectionAuthorityRequest = exports.parseCollectionPermanentDeleteRequest = exports.parseCollectionMembershipMutationResult = exports.parseLeaveCollectionRequest = exports.parseRemoveCollectionMemberRequest = exports.parseChangeCollectionMemberRoleRequest = void 0;
const collectionSharing_1 = require("./collectionSharing");
const accountItemBilling_1 = require("./accountItemBilling");
const canonical_1 = require("./canonical");
const paths_1 = require("./paths");
const values_1 = require("./values");
const record = (value, label) => {
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
        throw new Error(`${label} must be an object.`);
    }
    return value;
};
const string = (value, label) => {
    if (typeof value !== 'string' || !value)
        throw new Error(`${label} must be a non-empty string.`);
    return value;
};
const boundedString = (value, label, maximumUtf8Bytes, allowEmpty = false) => {
    if (typeof value !== 'string' || (!allowEmpty && !value)) {
        throw new Error(`${label} must be ${allowEmpty ? 'a string' : 'a non-empty string'}.`);
    }
    if (new TextEncoder().encode(value).byteLength > maximumUtf8Bytes) {
        throw new Error(`${label} is too long.`);
    }
    return value;
};
const isoInstant = (value, label) => {
    const instant = string(value, label);
    const milliseconds = Date.parse(instant);
    if (!Number.isFinite(milliseconds) ||
        new Date(milliseconds).toISOString() !== instant) {
        throw new Error(`${label} must be a canonical ISO instant.`);
    }
    return instant;
};
const exactKeys = (input, allowed, label) => {
    const unexpected = Object.keys(input).find((key) => !allowed.includes(key));
    if (unexpected)
        throw new Error(`${label}.${unexpected} is unsupported.`);
};
const optionalString = (value, label) => value === undefined ? undefined : string(value, label);
const boolean = (value, label) => {
    if (typeof value !== 'boolean')
        throw new Error(`${label} must be a boolean.`);
    return value;
};
const integer = (value, label, minimum = 0, maximum = Number.MAX_SAFE_INTEGER) => {
    if (!Number.isSafeInteger(value) ||
        value < minimum ||
        value > maximum) {
        throw new Error(`${label} must be an integer from ${minimum} through ${maximum}.`);
    }
    return value;
};
const signedInteger = (value, label) => {
    if (!Number.isSafeInteger(value))
        throw new Error(`${label} must be a safe integer.`);
    return value;
};
const optionalInteger = (value, label, minimum = 0) => value === undefined ? undefined : integer(value, label, minimum);
const member = (value, allowed, label) => {
    if (typeof value !== 'string' || !allowed.includes(value))
        throw new Error(`${label} is unsupported.`);
    return value;
};
const timestamp = (value, label) => {
    const input = record(value, label);
    return {
        seconds: signedInteger(input.seconds, `${label}.seconds`),
        nanoseconds: integer(input.nanoseconds, `${label}.nanoseconds`, 0, 999999999),
    };
};
const optionalTimestamp = (value, label) => value === undefined ? undefined : timestamp(value, label);
exports.GPS_DECIMAL_PLACES = 2;
const roundGpsCoordinates = (gps) => {
    const factor = 10 ** exports.GPS_DECIMAL_PLACES;
    return {
        latitude: Math.round(gps.latitude * factor) / factor,
        longitude: Math.round(gps.longitude * factor) / factor,
    };
};
exports.roundGpsCoordinates = roundGpsCoordinates;
const gpsCoordinates = (value, label) => {
    const input = record(value, label);
    exactKeys(input, ['latitude', 'longitude'], label);
    const latitude = input.latitude;
    const longitude = input.longitude;
    if (typeof latitude !== 'number' ||
        !Number.isFinite(latitude) ||
        latitude < -90 ||
        latitude > 90 ||
        typeof longitude !== 'number' ||
        !Number.isFinite(longitude) ||
        longitude < -180 ||
        longitude > 180) {
        throw new Error(`${label} must be a valid GPS coordinate.`);
    }
    return (0, exports.roundGpsCoordinates)({ latitude, longitude });
};
const optionalGps = (value, label) => value === undefined ? undefined : gpsCoordinates(value, label);
const compareTimestamps = (left, right) => left.seconds === right.seconds
    ? left.nanoseconds - right.nanoseconds
    : left.seconds - right.seconds;
const stringArray = (value, label) => {
    if (!Array.isArray(value))
        throw new Error(`${label} must be an array.`);
    return value.map((entry, index) => string(entry, `${label}[${index}]`));
};
const jsonUtf8Bytes = (value, label) => {
    let encoded;
    try {
        encoded = JSON.stringify(value);
    }
    catch {
        throw new Error(`${label} must be JSON-compatible.`);
    }
    if (encoded === undefined)
        throw new Error(`${label} must be JSON-compatible.`);
    return new TextEncoder().encode(encoded).byteLength;
};
const versioned = (input, label) => {
    const schemaVersion = integer(input.schemaVersion, `${label}.schemaVersion`, 1);
    if (schemaVersion !== values_1.SCHEMA_VERSION)
        throw new Error(`${label}.schemaVersion is unsupported.`);
    return {
        schemaVersion,
        revision: integer(input.revision, `${label}.revision`),
    };
};
const parseWith = (value, label, fields) => {
    const input = record(value, label);
    return { ...versioned(input, label), ...fields(input) };
};
const operationId = (value, label) => (0, paths_1.requireOperationId)(string(value, label));
const parseCursorPage = (value, parseItem) => {
    const input = record(value, 'cursorPage');
    if (!Array.isArray(input.items))
        throw new Error('cursorPage.items must be an array.');
    return {
        items: input.items.map(parseItem),
        nextCursor: optionalString(input.nextCursor, 'cursorPage.nextCursor'),
    };
};
exports.parseCursorPage = parseCursorPage;
const parseCollectionSummary = (value) => {
    const input = record(value, 'collectionSummary');
    const lifecycleVersion = input.lifecycleVersion === undefined
        ? undefined
        : integer(input.lifecycleVersion, 'collectionSummary.lifecycleVersion');
    const ownerUserId = optionalString(input.ownerUserId, 'collectionSummary.ownerUserId');
    const ownerUsername = optionalString(input.ownerUsername, 'collectionSummary.ownerUsername');
    const gps = optionalGps(input.gps, 'collectionSummary.gps');
    return {
        collectionId: string(input.collectionId, 'collectionSummary.collectionId'),
        name: string(input.name, 'collectionSummary.name'),
        role: member(input.role, values_1.COLLECTION_ROLES, 'collectionSummary.role'),
        lifecycle: member(input.lifecycle, values_1.COLLECTION_LIFECYCLES, 'collectionSummary.lifecycle'),
        membershipVersion: integer(input.membershipVersion, 'collectionSummary.membershipVersion'),
        ...(lifecycleVersion === undefined ? {} : { lifecycleVersion }),
        ...(ownerUserId === undefined ? {} : { ownerUserId }),
        ...(ownerUsername === undefined ? {} : { ownerUsername }),
        ...(gps === undefined ? {} : { gps }),
    };
};
exports.parseCollectionSummary = parseCollectionSummary;
const parseCollectionSession = (value) => {
    const input = record(value, 'collectionSession');
    const activeCollectionId = optionalString(input.activeCollectionId, 'collectionSession.activeCollectionId');
    const activeRole = input.activeRole === undefined
        ? undefined
        : member(input.activeRole, values_1.COLLECTION_ROLES, 'collectionSession.activeRole');
    const membershipVersion = optionalInteger(input.membershipVersion, 'collectionSession.membershipVersion');
    const hasCompleteActiveAuthority = activeCollectionId !== undefined &&
        activeRole !== undefined &&
        membershipVersion !== undefined;
    if ((activeCollectionId !== undefined ||
        activeRole !== undefined ||
        membershipVersion !== undefined) &&
        !hasCompleteActiveAuthority) {
        throw new Error('collectionSession active authority fields must be supplied together.');
    }
    return {
        userId: string(input.userId, 'collectionSession.userId'),
        availableCollections: (0, exports.parseCursorPage)(input.availableCollections, exports.parseCollectionSummary),
        activeCollectionId,
        activeRole,
        membershipVersion,
    };
};
exports.parseCollectionSession = parseCollectionSession;
const parseCollectionDocument = (value) => parseWith(value, 'collection', (input) => {
    const lifecycle = member(input.lifecycle, values_1.COLLECTION_LIFECYCLES, 'collection.lifecycle');
    const activeTransferId = optionalString(input.activeTransferId, 'collection.activeTransferId');
    const deletionRequestedAt = optionalTimestamp(input.deletionRequestedAt, 'collection.deletionRequestedAt');
    const permanentDeletionStartedAt = optionalTimestamp(input.permanentDeletionStartedAt, 'collection.permanentDeletionStartedAt');
    const deletedAt = optionalTimestamp(input.deletedAt, 'collection.deletedAt');
    const hasDeletionFields = Boolean(deletionRequestedAt || permanentDeletionStartedAt || deletedAt);
    if (lifecycle === 'transfer-pending' && !activeTransferId) {
        throw new Error('A transfer-pending collection requires activeTransferId.');
    }
    if (lifecycle !== 'transfer-pending' && activeTransferId) {
        throw new Error('activeTransferId is valid only while transfer-pending.');
    }
    if ((lifecycle === 'active' || lifecycle === 'transfer-pending') &&
        hasDeletionFields) {
        throw new Error(`${lifecycle} collections cannot retain deletion fields.`);
    }
    if (lifecycle === 'deleting' && !deletionRequestedAt) {
        throw new Error('A deleting collection requires deletionRequestedAt.');
    }
    if (lifecycle === 'deleting' && deletedAt) {
        throw new Error('A deleting collection cannot have deletedAt.');
    }
    if (lifecycle === 'deleted' && !deletedAt) {
        throw new Error('A deleted collection requires deletedAt.');
    }
    return {
        name: string(input.name, 'collection.name'),
        normalizedName: string(input.normalizedName, 'collection.normalizedName'),
        ownerUserId: string(input.ownerUserId, 'collection.ownerUserId'),
        billingAccountId: string(input.billingAccountId, 'collection.billingAccountId'),
        lifecycle,
        lifecycleVersion: integer(input.lifecycleVersion, 'collection.lifecycleVersion'),
        ...(input.gps === undefined
            ? {}
            : { gps: gpsCoordinates(input.gps, 'collection.gps') }),
        activeTransferId,
        deletionRequestedAt,
        permanentDeletionStartedAt,
        deletedAt,
        createdAt: timestamp(input.createdAt, 'collection.createdAt'),
        createdBy: string(input.createdBy, 'collection.createdBy'),
        updatedAt: timestamp(input.updatedAt, 'collection.updatedAt'),
    };
});
exports.parseCollectionDocument = parseCollectionDocument;
const parseCollectionMembershipDocument = (value) => parseWith(value, 'membership', (input) => ({
    collectionId: string(input.collectionId, 'membership.collectionId'),
    userId: string(input.userId, 'membership.userId'),
    role: member(input.role, values_1.COLLECTION_ROLES, 'membership.role'),
    status: member(input.status, values_1.MEMBERSHIP_STATUSES, 'membership.status'),
    invitedBy: optionalString(input.invitedBy, 'membership.invitedBy'),
    acceptedAt: optionalTimestamp(input.acceptedAt, 'membership.acceptedAt'),
    revokedAt: optionalTimestamp(input.revokedAt, 'membership.revokedAt'),
    membershipVersion: integer(input.membershipVersion, 'membership.membershipVersion'),
}));
exports.parseCollectionMembershipDocument = parseCollectionMembershipDocument;
const parseCollectionInvitationDocument = (value) => parseWith(value, 'invitation', (input) => {
    const status = member(input.status, ['pending', 'accepted', 'revoked', 'expired'], 'invitation.status');
    const exchangeTokenHash = optionalString(input.exchangeTokenHash, 'invitation.exchangeTokenHash');
    const exchangeExpiresAt = optionalTimestamp(input.exchangeExpiresAt, 'invitation.exchangeExpiresAt');
    if ((exchangeTokenHash === undefined) !==
        (exchangeExpiresAt === undefined)) {
        throw new Error('Invitation exchange identity is incomplete.');
    }
    const collectionId = string(input.collectionId, 'invitation.collectionId');
    paths_1.firestorePaths.collection(collectionId);
    const normalizedEmail = (0, canonical_1.normalizeVerifiedEmail)(string(input.normalizedEmail, 'invitation.normalizedEmail'));
    const tokenHash = string(input.tokenHash, 'invitation.tokenHash');
    if (!/^[a-f0-9]{64}$/u.test(tokenHash)) {
        throw new Error('Invitation token hash is invalid.');
    }
    if (exchangeTokenHash !== undefined &&
        !/^[a-f0-9]{64}$/u.test(exchangeTokenHash)) {
        throw new Error('Invitation exchange token hash is invalid.');
    }
    const createdAt = timestamp(input.createdAt, 'invitation.createdAt');
    const updatedAt = timestamp(input.updatedAt, 'invitation.updatedAt');
    const expiresAt = timestamp(input.expiresAt, 'invitation.expiresAt');
    if (compareTimestamps(updatedAt, createdAt) < 0 ||
        compareTimestamps(expiresAt, createdAt) <= 0) {
        throw new Error('Invitation timestamps are invalid.');
    }
    if (exchangeExpiresAt !== undefined &&
        (compareTimestamps(exchangeExpiresAt, updatedAt) <= 0 ||
            compareTimestamps(exchangeExpiresAt, expiresAt) > 0)) {
        throw new Error('Invitation exchange expiry is invalid.');
    }
    const acceptedByUserId = optionalString(input.acceptedByUserId, 'invitation.acceptedByUserId');
    if ((status === 'accepted') !== (acceptedByUserId !== undefined)) {
        throw new Error('Invitation acceptance identity is inconsistent.');
    }
    if (acceptedByUserId)
        paths_1.firestorePaths.member(collectionId, acceptedByUserId);
    return {
        collectionId,
        normalizedEmail,
        role: member(input.role, ['administrator', 'editor', 'viewer'], 'invitation.role'),
        invitedByUserId: string(input.invitedByUserId, 'invitation.invitedByUserId'),
        status,
        expiresAt,
        tokenHash,
        tokenGeneration: integer(input.tokenGeneration, 'invitation.tokenGeneration', 1),
        createdAt,
        updatedAt,
        acceptedByUserId,
        exchangeTokenHash,
        exchangeExpiresAt,
        deliveryState: member(input.deliveryState, ['disabled', 'queued', 'sent', 'failed'], 'invitation.deliveryState'),
    };
});
exports.parseCollectionInvitationDocument = parseCollectionInvitationDocument;
const parseCollectionTransferOutcome = (value) => {
    const input = record(value, 'transferOutcome');
    exactKeys(input, ['mode', 'capacity'], 'transferOutcome');
    return {
        mode: member(input.mode, ['account-billing'], 'transferOutcome.mode'),
        capacity: integer(input.capacity, 'transferOutcome.capacity', accountItemBilling_1.OPERATIONAL_ITEM_LIMIT, accountItemBilling_1.OPERATIONAL_ITEM_LIMIT),
    };
};
exports.parseCollectionTransferOutcome = parseCollectionTransferOutcome;
const parseCollectionTransferDocument = (value) => parseWith(value, 'transfer', (input) => ({
    ...(input.outcome === undefined
        ? {}
        : { outcome: (0, exports.parseCollectionTransferOutcome)(input.outcome) }),
    collectionId: string(input.collectionId, 'transfer.collectionId'),
    fromOwnerUserId: string(input.fromOwnerUserId, 'transfer.fromOwnerUserId'),
    toUserId: string(input.toUserId, 'transfer.toUserId'),
    sourceBillingAccountId: string(input.sourceBillingAccountId, 'transfer.sourceBillingAccountId'),
    destinationBillingAccountId: string(input.destinationBillingAccountId, 'transfer.destinationBillingAccountId'),
    expectedCollectionLifecycleVersion: integer(input.expectedCollectionLifecycleVersion, 'transfer.expectedCollectionLifecycleVersion'),
    status: member(input.status, [
        'pending-recipient',
        'ready',
        'complete',
        'cancelled',
        'expired',
    ], 'transfer.status'),
    expiresAt: timestamp(input.expiresAt, 'transfer.expiresAt'),
    operationId: operationId(input.operationId, 'transfer.operationId'),
}));
exports.parseCollectionTransferDocument = parseCollectionTransferDocument;
const parseCollectionAuditEventDocument = (value) => parseWith(value, 'auditEvent', (input) => ({
    eventId: string(input.eventId, 'auditEvent.eventId'),
    collectionId: string(input.collectionId, 'auditEvent.collectionId'),
    actorUserId: string(input.actorUserId, 'auditEvent.actorUserId'),
    eventType: string(input.eventType, 'auditEvent.eventType'),
    operationId: operationId(input.operationId, 'auditEvent.operationId'),
    catalogueVersion: optionalString(input.catalogueVersion, 'auditEvent.catalogueVersion'),
    effectiveLimit: optionalInteger(input.effectiveLimit, 'auditEvent.effectiveLimit'),
    createdAt: timestamp(input.createdAt, 'auditEvent.createdAt'),
}));
exports.parseCollectionAuditEventDocument = parseCollectionAuditEventDocument;
const parseStartCollectionTransferRequest = (value) => {
    const input = record(value, 'startCollectionTransfer');
    exactKeys(input, [
        'collectionId',
        'toUserId',
        'operationId',
        'expectedCollectionRevision',
        'expectedLifecycleVersion',
        'expectedRecipientRevision',
        'expectedRecipientMembershipVersion',
    ], 'startCollectionTransfer');
    const collectionId = string(input.collectionId, 'startCollectionTransfer.collectionId');
    const toUserId = string(input.toUserId, 'startCollectionTransfer.toUserId');
    paths_1.firestorePaths.collection(collectionId);
    paths_1.firestorePaths.member(collectionId, toUserId);
    return {
        collectionId,
        toUserId,
        operationId: operationId(input.operationId, 'startCollectionTransfer.operationId'),
        expectedCollectionRevision: integer(input.expectedCollectionRevision, 'startCollectionTransfer.expectedCollectionRevision', 0),
        expectedLifecycleVersion: integer(input.expectedLifecycleVersion, 'startCollectionTransfer.expectedLifecycleVersion', 0),
        expectedRecipientRevision: integer(input.expectedRecipientRevision, 'startCollectionTransfer.expectedRecipientRevision', 0),
        expectedRecipientMembershipVersion: integer(input.expectedRecipientMembershipVersion, 'startCollectionTransfer.expectedRecipientMembershipVersion', 0),
    };
};
exports.parseStartCollectionTransferRequest = parseStartCollectionTransferRequest;
const parseCollectionTransferActionRequest = (value, label) => {
    const input = record(value, label);
    exactKeys(input, [
        'collectionId',
        'transferId',
        'operationId',
        'expectedTransferRevision',
        'expectedOutcome',
    ], label);
    const collectionId = string(input.collectionId, `${label}.collectionId`);
    const transferId = string(input.transferId, `${label}.transferId`);
    paths_1.firestorePaths.transfer(collectionId, transferId);
    return {
        collectionId,
        transferId,
        operationId: operationId(input.operationId, `${label}.operationId`),
        ...(input.expectedOutcome === undefined
            ? {}
            : {
                expectedOutcome: (0, exports.parseCollectionTransferOutcome)(input.expectedOutcome),
            }),
        expectedTransferRevision: integer(input.expectedTransferRevision, `${label}.expectedTransferRevision`, 0),
    };
};
const parseAcceptCollectionTransferRequest = (value) => parseCollectionTransferActionRequest(value, 'acceptCollectionTransfer');
exports.parseAcceptCollectionTransferRequest = parseAcceptCollectionTransferRequest;
const parseCancelCollectionTransferRequest = (value) => parseCollectionTransferActionRequest(value, 'cancelCollectionTransfer');
exports.parseCancelCollectionTransferRequest = parseCancelCollectionTransferRequest;
const parseApplyCollectionTransferRequest = (value) => parseCollectionTransferActionRequest(value, 'applyCollectionTransfer');
exports.parseApplyCollectionTransferRequest = parseApplyCollectionTransferRequest;
const parseGetCollectionTransferRequest = (value) => {
    const input = record(value, 'getCollectionTransfer');
    exactKeys(input, ['collectionId'], 'getCollectionTransfer');
    const collectionId = string(input.collectionId, 'getCollectionTransfer.collectionId');
    paths_1.firestorePaths.collection(collectionId);
    return { collectionId };
};
exports.parseGetCollectionTransferRequest = parseGetCollectionTransferRequest;
const parseCollectionTransferResult = (value) => {
    const input = record(value, 'collectionTransferResult');
    exactKeys(input, [
        'collectionId',
        'transferId',
        'outcome',
        'fromOwnerUserId',
        'toUserId',
        'status',
        'revision',
        'expiresAt',
        'idempotent',
    ], 'collectionTransferResult');
    const collectionId = string(input.collectionId, 'collectionTransferResult.collectionId');
    const transferId = string(input.transferId, 'collectionTransferResult.transferId');
    const fromOwnerUserId = string(input.fromOwnerUserId, 'collectionTransferResult.fromOwnerUserId');
    const toUserId = string(input.toUserId, 'collectionTransferResult.toUserId');
    paths_1.firestorePaths.transfer(collectionId, transferId);
    paths_1.firestorePaths.member(collectionId, fromOwnerUserId);
    paths_1.firestorePaths.member(collectionId, toUserId);
    return {
        collectionId,
        transferId,
        fromOwnerUserId,
        toUserId,
        ...(input.outcome === undefined
            ? {}
            : { outcome: (0, exports.parseCollectionTransferOutcome)(input.outcome) }),
        status: member(input.status, [
            'pending-recipient',
            'ready',
            'complete',
            'cancelled',
            'expired',
        ], 'collectionTransferResult.status'),
        revision: integer(input.revision, 'collectionTransferResult.revision', 0),
        expiresAt: timestamp(input.expiresAt, 'collectionTransferResult.expiresAt'),
        idempotent: boolean(input.idempotent, 'collectionTransferResult.idempotent'),
    };
};
exports.parseCollectionTransferResult = parseCollectionTransferResult;
const parseDeleteCollectionRequest = (value) => {
    const input = record(value, 'deleteCollection');
    exactKeys(input, [
        'collectionId',
        'operationId',
        'confirmedName',
        'expectedCollectionRevision',
        'expectedLifecycleVersion',
    ], 'deleteCollection');
    const collectionId = string(input.collectionId, 'deleteCollection.collectionId');
    paths_1.firestorePaths.collection(collectionId);
    return {
        collectionId,
        operationId: operationId(input.operationId, 'deleteCollection.operationId'),
        confirmedName: boundedString(input.confirmedName, 'deleteCollection.confirmedName', 320),
        expectedCollectionRevision: integer(input.expectedCollectionRevision, 'deleteCollection.expectedCollectionRevision', 0),
        expectedLifecycleVersion: integer(input.expectedLifecycleVersion, 'deleteCollection.expectedLifecycleVersion', 0),
    };
};
exports.parseDeleteCollectionRequest = parseDeleteCollectionRequest;
const parseDeleteCollectionResult = (value) => {
    const input = record(value, 'deleteCollectionResult');
    exactKeys(input, ['collectionId', 'operationId', 'idempotent'], 'deleteCollectionResult');
    const collectionId = string(input.collectionId, 'deleteCollectionResult.collectionId');
    paths_1.firestorePaths.collection(collectionId);
    return {
        collectionId,
        operationId: operationId(input.operationId, 'deleteCollectionResult.operationId'),
        idempotent: boolean(input.idempotent, 'deleteCollectionResult.idempotent'),
    };
};
exports.parseDeleteCollectionResult = parseDeleteCollectionResult;
const parseCollectionAiPolicyDocument = (value) => parseWith(value, 'aiPolicy', (input) => ({
    collectionId: string(input.collectionId, 'aiPolicy.collectionId'),
    editorAiEnabled: boolean(input.editorAiEnabled, 'aiPolicy.editorAiEnabled'),
}));
exports.parseCollectionAiPolicyDocument = parseCollectionAiPolicyDocument;
const parseCollectionAiCacheEntryDocument = (value) => {
    const input = record(value, 'aiCacheEntry');
    exactKeys(input, [
        'schemaVersion',
        'revision',
        'cacheKey',
        'collectionId',
        'billingAccountId',
        'sourceHash',
        'sourceGeneration',
        'workflow',
        'feature',
        'providerModel',
        'preprocessingVersion',
        'sourceOperationId',
        'dispatchAttemptId',
        'providerRequestId',
        'extractedText',
        'keywords',
        'createdAt',
        'updatedAt',
        'sourceStoragePath',
    ], 'aiCacheEntry');
    const cacheKey = (0, paths_1.requireSha256)(string(input.cacheKey, 'aiCacheEntry.cacheKey'), 'AI cache key');
    const collectionId = boundedString(input.collectionId, 'aiCacheEntry.collectionId', 1500);
    const billingAccountId = boundedString(input.billingAccountId, 'aiCacheEntry.billingAccountId', 1500);
    paths_1.firestorePaths.aiCacheEntry(collectionId, cacheKey);
    paths_1.firestorePaths.billingAccount(billingAccountId);
    const feature = collectionAiFeature(input.feature, 'aiCacheEntry.feature');
    const extractedText = boundedString(input.extractedText, 'aiCacheEntry.extractedText', 8192, true);
    const keywords = stringArray(input.keywords, 'aiCacheEntry.keywords').map((keyword, index) => boundedString(keyword, `aiCacheEntry.keywords[${index}]`, 128).trim());
    if (keywords.length > 20 || keywords.some((keyword) => !keyword))
        throw new Error('Invalid AI keywords.');
    const createdAt = timestamp(input.createdAt, 'aiCacheEntry.createdAt');
    const updatedAt = timestamp(input.updatedAt, 'aiCacheEntry.updatedAt');
    if (compareTimestamps(updatedAt, createdAt) < 0)
        throw new Error('aiCacheEntry timestamps are invalid.');
    const sourceStoragePath = input.sourceStoragePath === undefined
        ? undefined
        : string(input.sourceStoragePath, 'aiCacheEntry.sourceStoragePath');
    if (sourceStoragePath !== undefined) {
        const prefix = `collections/${collectionId}/images/`;
        if (!sourceStoragePath.startsWith(prefix) ||
            paths_1.storagePaths.durableImage(collectionId, sourceStoragePath.slice(prefix.length)) !== sourceStoragePath) {
            throw new Error('aiCacheEntry source path is invalid.');
        }
    }
    return {
        ...versioned(input, 'aiCacheEntry'),
        cacheKey,
        collectionId,
        billingAccountId,
        sourceHash: boundedString(input.sourceHash, 'aiCacheEntry.sourceHash', 256),
        sourceGeneration: boundedString(input.sourceGeneration, 'aiCacheEntry.sourceGeneration', 128),
        workflow: collectionAiWorkflow(input.workflow, 'aiCacheEntry.workflow'),
        feature,
        providerModel: boundedString(input.providerModel, 'aiCacheEntry.providerModel', 256),
        preprocessingVersion: boundedString(input.preprocessingVersion, 'aiCacheEntry.preprocessingVersion', 128),
        sourceOperationId: operationId(input.sourceOperationId, 'aiCacheEntry.sourceOperationId'),
        dispatchAttemptId: operationId(input.dispatchAttemptId, 'aiCacheEntry.dispatchAttemptId'),
        providerRequestId: boundedString(input.providerRequestId, 'aiCacheEntry.providerRequestId', 256),
        extractedText,
        keywords,
        createdAt,
        updatedAt,
        ...(sourceStoragePath === undefined ? {} : { sourceStoragePath }),
    };
};
exports.parseCollectionAiCacheEntryDocument = parseCollectionAiCacheEntryDocument;
const parseBillingAccountDocument = (value) => parseWith(value, 'billingAccount', (input) => {
    const stripeCustomerProvisioning = input.stripeCustomerProvisioning === undefined
        ? undefined
        : (() => {
            const provisioning = record(input.stripeCustomerProvisioning, 'billingAccount.stripeCustomerProvisioning');
            exactKeys(provisioning, [
                'environment',
                'operationId',
                'leaseId',
                'leaseExpiresAt',
                'attempts',
                'state',
                'createdAt',
                'updatedAt',
            ], 'billingAccount.stripeCustomerProvisioning');
            const state = member(provisioning.state, ['processing', 'reconcile', 'complete'], 'billingAccount.stripeCustomerProvisioning.state');
            const leaseId = provisioning.leaseId === undefined
                ? undefined
                : operationId(provisioning.leaseId, 'billingAccount.stripeCustomerProvisioning.leaseId');
            const leaseExpiresAt = optionalTimestamp(provisioning.leaseExpiresAt, 'billingAccount.stripeCustomerProvisioning.leaseExpiresAt');
            if (state === 'processing' && (!leaseId || !leaseExpiresAt)) {
                throw new Error('Processing Stripe customer provisioning requires an exact lease.');
            }
            if (state !== 'processing' && (leaseId || leaseExpiresAt)) {
                throw new Error('Terminal Stripe customer provisioning cannot retain a lease.');
            }
            return {
                environment: member(provisioning.environment, ['test', 'live'], 'billingAccount.stripeCustomerProvisioning.environment'),
                operationId: operationId(provisioning.operationId, 'billingAccount.stripeCustomerProvisioning.operationId'),
                ...(leaseId === undefined ? {} : { leaseId }),
                ...(leaseExpiresAt === undefined ? {} : { leaseExpiresAt }),
                attempts: integer(provisioning.attempts, 'billingAccount.stripeCustomerProvisioning.attempts', 1),
                state,
                createdAt: timestamp(provisioning.createdAt, 'billingAccount.stripeCustomerProvisioning.createdAt'),
                updatedAt: timestamp(provisioning.updatedAt, 'billingAccount.stripeCustomerProvisioning.updatedAt'),
            };
        })();
    return {
        type: member(input.type, ['personal', 'shared', 'organization'], 'billingAccount.type'),
        ownerUserId: string(input.ownerUserId, 'billingAccount.ownerUserId'),
        currency: member(input.currency, ['NZD'], 'billingAccount.currency'),
        stripeCustomerId: optionalString(input.stripeCustomerId, 'billingAccount.stripeCustomerId'),
        ...(stripeCustomerProvisioning === undefined
            ? {}
            : { stripeCustomerProvisioning }),
        createdAt: timestamp(input.createdAt, 'billingAccount.createdAt'),
        updatedAt: timestamp(input.updatedAt, 'billingAccount.updatedAt'),
    };
});
exports.parseBillingAccountDocument = parseBillingAccountDocument;
const parseBillingAccountOwnerIndexDocument = (value) => parseWith(value, 'billingAccountOwner', (input) => {
    const provisioningSource = member(input.provisioningSource, ['verified-user'], 'billingAccountOwner.provisioningSource');
    return {
        ownerUserId: string(input.ownerUserId, 'billingAccountOwner.ownerUserId'),
        billingAccountId: string(input.billingAccountId, 'billingAccountOwner.billingAccountId'),
        createdAt: timestamp(input.createdAt, 'billingAccountOwner.createdAt'),
        ...(input.updatedAt === undefined
            ? {}
            : {
                updatedAt: timestamp(input.updatedAt, 'billingAccountOwner.updatedAt'),
            }),
        provisioningSource,
    };
});
exports.parseBillingAccountOwnerIndexDocument = parseBillingAccountOwnerIndexDocument;
const parseCollectionCapacityStateDocument = (value) => {
    const input = record(value, 'capacityState');
    exactKeys(input, [
        'schemaVersion',
        'revision',
        'collectionId',
        'billingAccountId',
        'access',
        'effectiveLimit',
        'countedItems',
        'reservedItems',
        'activeReconciliationId',
    ], 'capacityState');
    if (input.schemaVersion !== 3)
        throw new Error('Capacity schema is unsupported.');
    const collectionId = string(input.collectionId, 'capacityState.collectionId');
    const billingAccountId = string(input.billingAccountId, 'capacityState.billingAccountId');
    paths_1.firestorePaths.collection(collectionId);
    paths_1.firestorePaths.billingAccount(billingAccountId);
    return {
        schemaVersion: 3,
        revision: integer(input.revision, 'capacityState.revision'),
        collectionId,
        billingAccountId,
        access: member(input.access, values_1.CAPACITY_ACCESS_VALUES, 'capacityState.access'),
        effectiveLimit: integer(input.effectiveLimit, 'capacityState.effectiveLimit', accountItemBilling_1.OPERATIONAL_ITEM_LIMIT, accountItemBilling_1.OPERATIONAL_ITEM_LIMIT),
        countedItems: integer(input.countedItems, 'capacityState.countedItems'),
        reservedItems: integer(input.reservedItems, 'capacityState.reservedItems'),
        ...(input.activeReconciliationId === undefined
            ? {}
            : {
                activeReconciliationId: string(input.activeReconciliationId, 'capacityState.activeReconciliationId'),
            }),
    };
};
exports.parseCollectionCapacityStateDocument = parseCollectionCapacityStateDocument;
const parseCapacityReservationDocument = (value) => parseWith(value, 'capacityReservation', (input) => {
    const reservation = {
        reservationId: string(input.reservationId, 'capacityReservation.reservationId'),
        operationId: operationId(input.operationId, 'capacityReservation.operationId'),
        collectionId: string(input.collectionId, 'capacityReservation.collectionId'),
        actorUserId: string(input.actorUserId, 'capacityReservation.actorUserId'),
        workflow: (0, paths_1.requireWorkflow)(string(input.workflow, 'capacityReservation.workflow')),
        requestedItems: integer(input.requestedItems, 'capacityReservation.requestedItems', 1),
        state: member(input.state, ['reserved', 'consumed', 'released', 'expired'], 'capacityReservation.state'),
        expiresAt: timestamp(input.expiresAt, 'capacityReservation.expiresAt'),
        createdAt: timestamp(input.createdAt, 'capacityReservation.createdAt'),
        updatedAt: timestamp(input.updatedAt, 'capacityReservation.updatedAt'),
    };
    if (reservation.expiresAt.seconds * 1000 +
        Math.floor(reservation.expiresAt.nanoseconds / 1000000) <=
        reservation.createdAt.seconds * 1000 +
            Math.floor(reservation.createdAt.nanoseconds / 1000000)) {
        throw new Error('capacityReservation.expiresAt must follow createdAt.');
    }
    return reservation;
});
exports.parseCapacityReservationDocument = parseCapacityReservationDocument;
const parseOperationClaimDocument = (value, expected) => {
    const claim = parseWith(value, 'operationClaim', (input) => {
        const payloadHashVersion = string(input.payloadHashVersion, 'operationClaim.payloadHashVersion');
        if (payloadHashVersion !== values_1.OPERATION_PAYLOAD_HASH_VERSION) {
            throw new Error('operationClaim.payloadHashVersion is unsupported.');
        }
        const canonicalPayloadHash = string(input.canonicalPayloadHash, 'operationClaim.canonicalPayloadHash');
        if (!/^[0-9a-f]{64}$/.test(canonicalPayloadHash)) {
            throw new Error('operationClaim.canonicalPayloadHash must be lowercase SHA-256.');
        }
        return {
            operationId: operationId(input.operationId, 'operationClaim.operationId'),
            authorityId: string(input.authorityId, 'operationClaim.authorityId'),
            actorUserId: string(input.actorUserId, 'operationClaim.actorUserId'),
            workflow: (0, paths_1.requireWorkflow)(string(input.workflow, 'operationClaim.workflow')),
            payloadHashVersion,
            canonicalPayloadHash,
            state: member(input.state, values_1.OPERATION_STATES, 'operationClaim.state'),
            resultId: optionalString(input.resultId, 'operationClaim.resultId'),
            retentionClass: member(input.retentionClass, values_1.OPERATION_RETENTION_CLASSES, 'operationClaim.retentionClass'),
            createdAt: timestamp(input.createdAt, 'operationClaim.createdAt'),
            updatedAt: timestamp(input.updatedAt, 'operationClaim.updatedAt'),
        };
    });
    if (expected &&
        (claim.authorityId !== expected.authorityId ||
            claim.workflow !== (0, paths_1.requireWorkflow)(expected.workflow) ||
            claim.operationId !== (0, paths_1.requireOperationId)(expected.operationId))) {
        throw new Error('Operation claim identity does not match its authoritative path.');
    }
    return claim;
};
exports.parseOperationClaimDocument = parseOperationClaimDocument;
const parseCollectionItemCreatePayload = (value, collectionId) => {
    const input = record(value, 'createCollectionItem.item');
    exactKeys(input, [
        'keywords',
        'location',
        'locationId',
        'qty',
        'image',
        'storagePath',
        'captureOperationId',
        'tagIds',
    ], 'createCollectionItem.item');
    const keywords = boundedString(input.keywords, 'createCollectionItem.item.keywords', 32 * 1024, true).trim();
    const location = boundedString(input.location, 'createCollectionItem.item.location', 4 * 1024).trim();
    if (!location)
        throw new Error('createCollectionItem.item.location must not be blank.');
    const locationId = input.locationId === undefined
        ? undefined
        : boundedString(input.locationId, 'createCollectionItem.item.locationId', 1500);
    if (locationId !== undefined)
        paths_1.firestorePaths.location(collectionId, locationId);
    const image = input.image === undefined
        ? undefined
        : boundedString(input.image, 'createCollectionItem.item.image', 8 * 1024, true);
    const storagePath = input.storagePath === undefined
        ? undefined
        : boundedString(input.storagePath, 'createCollectionItem.item.storagePath', 1024);
    if (storagePath !== undefined) {
        const prefix = `${paths_1.firestorePaths.collection(collectionId)}/images/`;
        if (!storagePath.startsWith(prefix)) {
            throw new Error('createCollectionItem.item.storagePath does not belong to the collection.');
        }
        const fileName = storagePath.slice(prefix.length);
        if (paths_1.storagePaths.durableImage(collectionId, fileName) !== storagePath) {
            throw new Error('createCollectionItem.item.storagePath is invalid.');
        }
    }
    const captureOperationId = input.captureOperationId === undefined
        ? undefined
        : (0, paths_1.requireOperationId)(string(input.captureOperationId, 'createCollectionItem.item.captureOperationId'));
    return {
        keywords,
        location,
        qty: integer(input.qty, 'createCollectionItem.item.qty', 0),
        ...(locationId === undefined ? {} : { locationId }),
        ...(image === undefined ? {} : { image }),
        ...(storagePath === undefined ? {} : { storagePath }),
        ...(captureOperationId === undefined ? {} : { captureOperationId }),
        ...(input.tagIds === undefined
            ? {}
            : { tagIds: (0, collectionSharing_1.parseTagIds)(input.tagIds) }),
    };
};
exports.parseCollectionItemCreatePayload = parseCollectionItemCreatePayload;
const parseCreateCollectionItemRequest = (value) => {
    const input = record(value, 'createCollectionItem');
    exactKeys(input, [
        'collectionId',
        'operationId',
        'itemId',
        'expectedMembershipVersion',
        'item',
    ], 'createCollectionItem');
    const collectionId = string(input.collectionId, 'createCollectionItem.collectionId');
    paths_1.firestorePaths.collection(collectionId);
    const itemId = input.itemId === undefined
        ? undefined
        : string(input.itemId, 'createCollectionItem.itemId');
    if (itemId !== undefined)
        paths_1.firestorePaths.item(collectionId, itemId);
    const expectedMembershipVersion = input.expectedMembershipVersion === undefined
        ? undefined
        : integer(input.expectedMembershipVersion, 'createCollectionItem.expectedMembershipVersion', 0);
    const parsedOperationId = (0, paths_1.requireOperationId)(string(input.operationId, 'createCollectionItem.operationId'));
    const item = (0, exports.parseCollectionItemCreatePayload)(input.item, collectionId);
    const rapidCaptureFieldsPresent = itemId !== undefined ||
        expectedMembershipVersion !== undefined ||
        item.captureOperationId !== undefined;
    if (rapidCaptureFieldsPresent &&
        (itemId === undefined ||
            expectedMembershipVersion === undefined ||
            item.captureOperationId !== parsedOperationId)) {
        throw new Error('createCollectionItem Rapid Capture identity is incomplete.');
    }
    return {
        collectionId,
        operationId: parsedOperationId,
        ...(itemId === undefined ? {} : { itemId }),
        ...(expectedMembershipVersion === undefined
            ? {}
            : { expectedMembershipVersion }),
        item,
    };
};
exports.parseCreateCollectionItemRequest = parseCreateCollectionItemRequest;
const parseCollectionBulkItemUpdates = (value, collectionId, label) => {
    const input = record(value, label);
    const allowed = [
        'keywords',
        'location',
        'locationId',
        'qty',
        'deleted',
        'image',
        'storagePath',
        'tagIds',
    ];
    exactKeys(input, allowed, label);
    if (Object.keys(input).length === 0) {
        throw new Error(`${label} must contain at least one update.`);
    }
    const updates = {};
    if (input.tagIds !== undefined)
        updates.tagIds = (0, collectionSharing_1.parseTagIds)(input.tagIds);
    if (input.keywords !== undefined) {
        const keywords = boundedString(input.keywords, `${label}.keywords`, 32 * 1024, true).trim();
        updates.keywords = keywords;
    }
    if (input.location !== undefined) {
        const location = boundedString(input.location, `${label}.location`, 4 * 1024).trim();
        if (!location)
            throw new Error(`${label}.location must not be blank.`);
        updates.location = location;
    }
    if (input.locationId !== undefined) {
        const locationId = boundedString(input.locationId, `${label}.locationId`, 1500, true);
        if (locationId)
            paths_1.firestorePaths.location(collectionId, locationId);
        updates.locationId = locationId;
    }
    if (input.qty !== undefined)
        updates.qty = integer(input.qty, `${label}.qty`, 0);
    if (input.deleted !== undefined)
        updates.deleted = boolean(input.deleted, `${label}.deleted`);
    if (input.image !== undefined) {
        updates.image = boundedString(input.image, `${label}.image`, 8 * 1024, true);
    }
    if (input.storagePath !== undefined) {
        const storagePath = boundedString(input.storagePath, `${label}.storagePath`, 1024, true);
        if (storagePath) {
            const prefix = `${paths_1.firestorePaths.collection(collectionId)}/images/`;
            if (!storagePath.startsWith(prefix)) {
                throw new Error(`${label}.storagePath does not belong to the collection.`);
            }
            const fileName = storagePath.slice(prefix.length);
            if (paths_1.storagePaths.durableImage(collectionId, fileName) !== storagePath) {
                throw new Error(`${label}.storagePath is invalid.`);
            }
        }
        updates.storagePath = storagePath;
    }
    return updates;
};
const parseCollectionBulkUpdateRequest = (value) => {
    if (jsonUtf8Bytes(value, 'collectionBulkUpdate') >
        values_1.MAX_COLLECTION_BULK_REQUEST_BYTES) {
        throw new Error('collectionBulkUpdate is too large.');
    }
    const input = record(value, 'collectionBulkUpdate');
    exactKeys(input, ['collectionId', 'operationId', 'items'], 'collectionBulkUpdate');
    const collectionId = string(input.collectionId, 'collectionBulkUpdate.collectionId');
    paths_1.firestorePaths.collection(collectionId);
    if (!Array.isArray(input.items) ||
        input.items.length === 0 ||
        input.items.length > values_1.MAX_COLLECTION_BULK_ITEMS) {
        throw new Error(`collectionBulkUpdate.items must contain 1 to ${values_1.MAX_COLLECTION_BULK_ITEMS} items.`);
    }
    const items = input.items.map((value, index) => {
        const item = record(value, `collectionBulkUpdate.items[${index}]`);
        exactKeys(item, ['id', 'updates', 'expectedRevision'], `collectionBulkUpdate.items[${index}]`);
        const id = string(item.id, `collectionBulkUpdate.items[${index}].id`);
        paths_1.firestorePaths.item(collectionId, id);
        return {
            id,
            ...(item.expectedRevision === undefined
                ? {}
                : {
                    expectedRevision: integer(item.expectedRevision, 'item.expectedRevision', 0),
                }),
            updates: parseCollectionBulkItemUpdates(item.updates, collectionId, `collectionBulkUpdate.items[${index}].updates`),
        };
    });
    if (new Set(items.map(({ id }) => id)).size !== items.length) {
        throw new Error('collectionBulkUpdate.items contains duplicate item IDs.');
    }
    return {
        collectionId,
        operationId: (0, paths_1.requireOperationId)(string(input.operationId, 'collectionBulkUpdate.operationId')),
        items: [...items].sort((left, right) => left.id < right.id ? -1 : left.id > right.id ? 1 : 0),
    };
};
exports.parseCollectionBulkUpdateRequest = parseCollectionBulkUpdateRequest;
const parseBillingProvisioningAuditEventDocument = (value) => parseWith(value, 'billingProvisioningAuditEvent', (input) => {
    const provisioningSource = member(input.provisioningSource, ['verified-user'], 'billingProvisioningAuditEvent.provisioningSource');
    return {
        eventId: string(input.eventId, 'billingProvisioningAuditEvent.eventId'),
        billingAccountId: string(input.billingAccountId, 'billingProvisioningAuditEvent.billingAccountId'),
        ownerUserId: string(input.ownerUserId, 'billingProvisioningAuditEvent.ownerUserId'),
        provisioningSource,
        reasonCode: member(input.reasonCode, ['personal-account-created', 'personal-account-reused'], 'billingProvisioningAuditEvent.reasonCode'),
        createdAt: timestamp(input.createdAt, 'billingProvisioningAuditEvent.createdAt'),
    };
});
exports.parseBillingProvisioningAuditEventDocument = parseBillingProvisioningAuditEventDocument;
const parseBillingProvisioningConflictDocument = (value) => parseWith(value, 'billingProvisioningConflict', (input) => ({
    ownerUserId: string(input.ownerUserId, 'billingProvisioningConflict.ownerUserId'),
    reasonCode: member(input.reasonCode, [
        'index-invalid',
        'account-missing',
        'account-invalid',
        'identity-mismatch',
        'reserved-account-type',
        'unindexed-account',
    ], 'billingProvisioningConflict.reasonCode'),
    attempts: integer(input.attempts, 'billingProvisioningConflict.attempts', 1),
    observedAt: timestamp(input.observedAt, 'billingProvisioningConflict.observedAt'),
}));
exports.parseBillingProvisioningConflictDocument = parseBillingProvisioningConflictDocument;
const parseCapacityReconciliationDocument = (value) => parseWith(value, 'capacityReconciliation', (input) => {
    const reconciliation = {
        reconciliationId: string(input.reconciliationId, 'capacityReconciliation.reconciliationId'),
        operationId: operationId(input.operationId, 'capacityReconciliation.operationId'),
        collectionId: string(input.collectionId, 'capacityReconciliation.collectionId'),
        actorUserId: string(input.actorUserId, 'capacityReconciliation.actorUserId'),
        cause: member(input.cause, [
            'scheduled-count',
            'ai-recovery',
            'workflow-recovery',
            'support-investigation',
        ], 'capacityReconciliation.cause'),
        expectedCountedItems: integer(input.expectedCountedItems, 'capacityReconciliation.expectedCountedItems', 0),
        observedCountedItems: input.observedCountedItems === undefined
            ? undefined
            : integer(input.observedCountedItems, 'capacityReconciliation.observedCountedItems', 0),
        expectedReservedItems: integer(input.expectedReservedItems, 'capacityReconciliation.expectedReservedItems', 0),
        observedReservedItems: input.observedReservedItems === undefined
            ? undefined
            : integer(input.observedReservedItems, 'capacityReconciliation.observedReservedItems', 0),
        capacityRevisionAtObservation: input.capacityRevisionAtObservation === undefined
            ? undefined
            : integer(input.capacityRevisionAtObservation, 'capacityReconciliation.capacityRevisionAtObservation', 0),
        state: member(input.state, ['observing', 'detected', 'clear', 'repaired'], 'capacityReconciliation.state'),
        repairOperationId: input.repairOperationId === undefined
            ? undefined
            : operationId(input.repairOperationId, 'capacityReconciliation.repairOperationId'),
        createdAt: timestamp(input.createdAt, 'capacityReconciliation.createdAt'),
        updatedAt: timestamp(input.updatedAt, 'capacityReconciliation.updatedAt'),
    };
    if ((reconciliation.state === 'repaired' &&
        !reconciliation.repairOperationId) ||
        (reconciliation.state !== 'repaired' &&
            reconciliation.repairOperationId) ||
        (reconciliation.state === 'observing' &&
            (reconciliation.observedCountedItems !== undefined ||
                reconciliation.observedReservedItems !== undefined ||
                reconciliation.capacityRevisionAtObservation !== undefined)) ||
        (reconciliation.state !== 'observing' &&
            (reconciliation.observedCountedItems === undefined ||
                reconciliation.observedReservedItems === undefined ||
                reconciliation.capacityRevisionAtObservation === undefined))) {
        throw new Error('capacityReconciliation repair identity is inconsistent.');
    }
    return reconciliation;
});
exports.parseCapacityReconciliationDocument = parseCapacityReconciliationDocument;
const parseCreateCollectionRequest = (value) => {
    const input = record(value, 'createCollection');
    exactKeys(input, ['operationId', 'name'], 'createCollection');
    return {
        operationId: operationId(input.operationId, 'createCollection.operationId'),
        name: (0, canonical_1.normalizeCollectionName)(boundedString(input.name, 'createCollection.name', 320)).name,
    };
};
exports.parseCreateCollectionRequest = parseCreateCollectionRequest;
const parseCreateCollectionResult = (value) => {
    const input = record(value, 'createCollectionResult');
    exactKeys(input, ['collectionId', 'billingAccountId', 'effectiveLimit', 'idempotent'], 'createCollectionResult');
    const collectionId = string(input.collectionId, 'createCollectionResult.collectionId');
    const billingAccountId = string(input.billingAccountId, 'createCollectionResult.billingAccountId');
    paths_1.firestorePaths.collection(collectionId);
    paths_1.firestorePaths.billingAccount(billingAccountId);
    integer(input.effectiveLimit, 'createCollectionResult.effectiveLimit', accountItemBilling_1.OPERATIONAL_ITEM_LIMIT, accountItemBilling_1.OPERATIONAL_ITEM_LIMIT);
    return {
        collectionId,
        billingAccountId,
        effectiveLimit: 100000,
        idempotent: boolean(input.idempotent, 'createCollectionResult.idempotent'),
    };
};
exports.parseCreateCollectionResult = parseCreateCollectionResult;
const parseUpdateCollectionRequest = (value) => {
    const input = record(value, 'updateCollection');
    exactKeys(input, [
        'collectionId',
        'operationId',
        'patch',
        'expectedRevision',
        'expectedLifecycleVersion',
    ], 'updateCollection');
    const collectionId = string(input.collectionId, 'updateCollection.collectionId');
    paths_1.firestorePaths.collection(collectionId);
    const patch = record(input.patch, 'updateCollection.patch');
    exactKeys(patch, ['name', 'gps'], 'updateCollection.patch');
    if (!Object.keys(patch).length)
        throw new Error('Collection update requires at least one field.');
    return {
        collectionId,
        operationId: operationId(input.operationId, 'updateCollection.operationId'),
        patch: {
            ...(Object.prototype.hasOwnProperty.call(patch, 'name')
                ? {
                    name: (0, canonical_1.normalizeCollectionName)(boundedString(patch.name, 'updateCollection.patch.name', 320)).name,
                }
                : {}),
            ...(Object.prototype.hasOwnProperty.call(patch, 'gps')
                ? {
                    gps: patch.gps === null
                        ? null
                        : gpsCoordinates(patch.gps, 'updateCollection.patch.gps'),
                }
                : {}),
        },
        expectedRevision: integer(input.expectedRevision, 'updateCollection.expectedRevision'),
        expectedLifecycleVersion: integer(input.expectedLifecycleVersion, 'updateCollection.expectedLifecycleVersion'),
    };
};
exports.parseUpdateCollectionRequest = parseUpdateCollectionRequest;
const parseUpdateCollectionResult = (value) => {
    const input = record(value, 'updateCollectionResult');
    exactKeys(input, ['collectionId', 'revision', 'idempotent'], 'updateCollectionResult');
    const collectionId = string(input.collectionId, 'updateCollectionResult.collectionId');
    paths_1.firestorePaths.collection(collectionId);
    return {
        collectionId,
        revision: integer(input.revision, 'updateCollectionResult.revision'),
        idempotent: boolean(input.idempotent, 'updateCollectionResult.idempotent'),
    };
};
exports.parseUpdateCollectionResult = parseUpdateCollectionResult;
const peoplePageSize = (value) => {
    if (value === undefined)
        return values_1.DEFAULT_COLLECTION_PEOPLE_PAGE_SIZE;
    const parsed = integer(value, 'collectionPeople.pageSize', 1, 50);
    if (!values_1.COLLECTION_PEOPLE_PAGE_SIZES.includes(parsed)) {
        throw new Error('collectionPeople.pageSize is unsupported.');
    }
    return parsed;
};
const pageCursor = (value, label) => value === undefined ? undefined : boundedString(value, label, 2048);
const invitationToken = (value, label) => {
    const parsed = boundedString(value, label, 512);
    if (!/^[A-Za-z0-9_-]{32,512}$/u.test(parsed)) {
        throw new Error(`${label} is invalid.`);
    }
    return parsed;
};
const parseListCollectionPeopleRequest = (value) => {
    const input = record(value, 'listCollectionPeople');
    exactKeys(input, ['collectionId', 'pageSize', 'memberCursor', 'invitationCursor'], 'listCollectionPeople');
    const collectionId = string(input.collectionId, 'listCollectionPeople.collectionId');
    paths_1.firestorePaths.collection(collectionId);
    return {
        collectionId,
        pageSize: peoplePageSize(input.pageSize),
        memberCursor: pageCursor(input.memberCursor, 'listCollectionPeople.memberCursor'),
        invitationCursor: pageCursor(input.invitationCursor, 'listCollectionPeople.invitationCursor'),
    };
};
exports.parseListCollectionPeopleRequest = parseListCollectionPeopleRequest;
const parseCreateCollectionInvitationRequest = (value) => {
    const input = record(value, 'createCollectionInvitation');
    exactKeys(input, ['collectionId', 'operationId', 'email', 'role'], 'createCollectionInvitation');
    const collectionId = string(input.collectionId, 'createCollectionInvitation.collectionId');
    paths_1.firestorePaths.collection(collectionId);
    return {
        collectionId,
        operationId: operationId(input.operationId, 'createCollectionInvitation.operationId'),
        email: (0, canonical_1.normalizeVerifiedEmail)(boundedString(input.email, 'createCollectionInvitation.email', 320)),
        role: member(input.role, ['administrator', 'editor', 'viewer'], 'createCollectionInvitation.role'),
    };
};
exports.parseCreateCollectionInvitationRequest = parseCreateCollectionInvitationRequest;
const parseExistingInvitationMutation = (value, label) => {
    const input = record(value, label);
    exactKeys(input, ['collectionId', 'invitationId', 'operationId', 'expectedRevision'], label);
    const collectionId = string(input.collectionId, `${label}.collectionId`);
    const invitationId = string(input.invitationId, `${label}.invitationId`);
    paths_1.firestorePaths.invitation(collectionId, invitationId);
    return {
        collectionId,
        invitationId,
        operationId: operationId(input.operationId, `${label}.operationId`),
        expectedRevision: integer(input.expectedRevision, `${label}.expectedRevision`),
    };
};
const parseResendCollectionInvitationRequest = (value) => parseExistingInvitationMutation(value, 'resendCollectionInvitation');
exports.parseResendCollectionInvitationRequest = parseResendCollectionInvitationRequest;
const parseRevokeCollectionInvitationRequest = (value) => parseExistingInvitationMutation(value, 'revokeCollectionInvitation');
exports.parseRevokeCollectionInvitationRequest = parseRevokeCollectionInvitationRequest;
const parseExchangeCollectionInvitationRequest = (value) => {
    const input = record(value, 'exchangeCollectionInvitation');
    exactKeys(input, ['token'], 'exchangeCollectionInvitation');
    return {
        token: invitationToken(input.token, 'exchangeCollectionInvitation.token'),
    };
};
exports.parseExchangeCollectionInvitationRequest = parseExchangeCollectionInvitationRequest;
const parseInvitationDecisionRequest = (value, label) => {
    const input = record(value, label);
    exactKeys(input, ['operationId', 'exchangeToken'], label);
    return {
        operationId: operationId(input.operationId, `${label}.operationId`),
        exchangeToken: invitationToken(input.exchangeToken, `${label}.exchangeToken`),
    };
};
const parseAcceptCollectionInvitationRequest = (value) => parseInvitationDecisionRequest(value, 'acceptCollectionInvitation');
exports.parseAcceptCollectionInvitationRequest = parseAcceptCollectionInvitationRequest;
const parseDeclineCollectionInvitationRequest = (value) => parseInvitationDecisionRequest(value, 'declineCollectionInvitation');
exports.parseDeclineCollectionInvitationRequest = parseDeclineCollectionInvitationRequest;
const parseCollectionMemberSummary = (value) => {
    const input = record(value, 'collectionMemberSummary');
    exactKeys(input, [
        'userId',
        'displayName',
        'role',
        'status',
        'revision',
        'membershipVersion',
    ], 'collectionMemberSummary');
    const userId = string(input.userId, 'collectionMemberSummary.userId');
    paths_1.firestorePaths.member('presentation-scope', userId);
    return {
        userId,
        displayName: boundedString(input.displayName, 'collectionMemberSummary.displayName', 512),
        role: member(input.role, values_1.COLLECTION_ROLES, 'collectionMemberSummary.role'),
        status: member(input.status, values_1.MEMBERSHIP_STATUSES, 'collectionMemberSummary.status'),
        revision: integer(input.revision, 'collectionMemberSummary.revision'),
        membershipVersion: integer(input.membershipVersion, 'collectionMemberSummary.membershipVersion'),
    };
};
exports.parseCollectionMemberSummary = parseCollectionMemberSummary;
const parseCollectionInvitationSummary = (value) => {
    const input = record(value, 'collectionInvitationSummary');
    exactKeys(input, [
        'invitationId',
        'email',
        'role',
        'status',
        'revision',
        'expiresAt',
        'deliveryState',
    ], 'collectionInvitationSummary');
    const invitationId = string(input.invitationId, 'collectionInvitationSummary.invitationId');
    paths_1.firestorePaths.invitation('presentation-scope', invitationId);
    return {
        invitationId,
        email: (0, canonical_1.normalizeVerifiedEmail)(string(input.email, 'collectionInvitationSummary.email')),
        role: member(input.role, ['administrator', 'editor', 'viewer'], 'collectionInvitationSummary.role'),
        status: member(input.status, ['pending', 'accepted', 'revoked', 'expired'], 'collectionInvitationSummary.status'),
        revision: integer(input.revision, 'collectionInvitationSummary.revision'),
        expiresAt: timestamp(input.expiresAt, 'collectionInvitationSummary.expiresAt'),
        deliveryState: member(input.deliveryState, ['disabled', 'queued', 'sent', 'failed'], 'collectionInvitationSummary.deliveryState'),
    };
};
exports.parseCollectionInvitationSummary = parseCollectionInvitationSummary;
const parseListCollectionPeopleResult = (value) => {
    const input = record(value, 'listCollectionPeopleResult');
    exactKeys(input, ['members', 'invitations'], 'listCollectionPeopleResult');
    return {
        members: (0, exports.parseCursorPage)(input.members, exports.parseCollectionMemberSummary),
        invitations: (0, exports.parseCursorPage)(input.invitations, exports.parseCollectionInvitationSummary),
    };
};
exports.parseListCollectionPeopleResult = parseListCollectionPeopleResult;
const parseCollectionInvitationMutationResult = (value) => {
    const input = record(value, 'collectionInvitationMutationResult');
    exactKeys(input, ['collectionId', 'invitationId', 'status', 'idempotent'], 'collectionInvitationMutationResult');
    const collectionId = string(input.collectionId, 'collectionInvitationMutationResult.collectionId');
    const invitationId = string(input.invitationId, 'collectionInvitationMutationResult.invitationId');
    paths_1.firestorePaths.invitation(collectionId, invitationId);
    return {
        collectionId,
        invitationId,
        status: member(input.status, ['accepted-for-processing'], 'collectionInvitationMutationResult.status'),
        idempotent: boolean(input.idempotent, 'collectionInvitationMutationResult.idempotent'),
    };
};
exports.parseCollectionInvitationMutationResult = parseCollectionInvitationMutationResult;
const parseExchangeCollectionInvitationResult = (value) => {
    const input = record(value, 'exchangeCollectionInvitationResult');
    exactKeys(input, ['exchangeToken', 'expiresAt'], 'exchangeCollectionInvitationResult');
    return {
        exchangeToken: invitationToken(input.exchangeToken, 'exchangeCollectionInvitationResult.exchangeToken'),
        expiresAt: timestamp(input.expiresAt, 'exchangeCollectionInvitationResult.expiresAt'),
    };
};
exports.parseExchangeCollectionInvitationResult = parseExchangeCollectionInvitationResult;
const parseAcceptCollectionInvitationResult = (value) => {
    const input = record(value, 'acceptCollectionInvitationResult');
    exactKeys(input, ['collectionId', 'idempotent'], 'acceptCollectionInvitationResult');
    const collectionId = string(input.collectionId, 'acceptCollectionInvitationResult.collectionId');
    paths_1.firestorePaths.collection(collectionId);
    return {
        collectionId,
        idempotent: boolean(input.idempotent, 'acceptCollectionInvitationResult.idempotent'),
    };
};
exports.parseAcceptCollectionInvitationResult = parseAcceptCollectionInvitationResult;
const parseDeclineCollectionInvitationResult = (value) => {
    const input = record(value, 'declineCollectionInvitationResult');
    exactKeys(input, ['declined', 'idempotent'], 'declineCollectionInvitationResult');
    if (input.declined !== true) {
        throw new Error('declineCollectionInvitationResult.declined must be true.');
    }
    return {
        declined: true,
        idempotent: boolean(input.idempotent, 'declineCollectionInvitationResult.idempotent'),
    };
};
exports.parseDeclineCollectionInvitationResult = parseDeclineCollectionInvitationResult;
const parseTargetMembershipMutationRequest = (value, label) => {
    const input = record(value, label);
    exactKeys(input, [
        'collectionId',
        'targetUserId',
        'operationId',
        'expectedRevision',
        'expectedMembershipVersion',
        'expectedRole',
    ], label);
    const collectionId = string(input.collectionId, `${label}.collectionId`);
    const targetUserId = string(input.targetUserId, `${label}.targetUserId`);
    paths_1.firestorePaths.member(collectionId, targetUserId);
    return {
        collectionId,
        targetUserId,
        operationId: operationId(input.operationId, `${label}.operationId`),
        expectedRevision: integer(input.expectedRevision, `${label}.expectedRevision`),
        expectedMembershipVersion: integer(input.expectedMembershipVersion, `${label}.expectedMembershipVersion`),
        expectedRole: member(input.expectedRole, ['administrator', 'editor', 'viewer'], `${label}.expectedRole`),
    };
};
const parseChangeCollectionMemberRoleRequest = (value) => {
    const input = record(value, 'changeCollectionMemberRole');
    exactKeys(input, [
        'collectionId',
        'targetUserId',
        'operationId',
        'expectedRevision',
        'expectedMembershipVersion',
        'role',
    ], 'changeCollectionMemberRole');
    const collectionId = string(input.collectionId, 'changeCollectionMemberRole.collectionId');
    const targetUserId = string(input.targetUserId, 'changeCollectionMemberRole.targetUserId');
    paths_1.firestorePaths.member(collectionId, targetUserId);
    return {
        collectionId,
        targetUserId,
        operationId: operationId(input.operationId, 'changeCollectionMemberRole.operationId'),
        expectedRevision: integer(input.expectedRevision, 'changeCollectionMemberRole.expectedRevision'),
        expectedMembershipVersion: integer(input.expectedMembershipVersion, 'changeCollectionMemberRole.expectedMembershipVersion'),
        role: member(input.role, ['administrator', 'editor', 'viewer'], 'changeCollectionMemberRole.role'),
    };
};
exports.parseChangeCollectionMemberRoleRequest = parseChangeCollectionMemberRoleRequest;
const parseRemoveCollectionMemberRequest = (value) => parseTargetMembershipMutationRequest(value, 'removeCollectionMember');
exports.parseRemoveCollectionMemberRequest = parseRemoveCollectionMemberRequest;
const parseLeaveCollectionRequest = (value) => {
    const input = record(value, 'leaveCollection');
    exactKeys(input, [
        'collectionId',
        'operationId',
        'expectedRevision',
        'expectedMembershipVersion',
        'expectedRole',
    ], 'leaveCollection');
    const collectionId = string(input.collectionId, 'leaveCollection.collectionId');
    paths_1.firestorePaths.collection(collectionId);
    return {
        collectionId,
        operationId: operationId(input.operationId, 'leaveCollection.operationId'),
        expectedRevision: integer(input.expectedRevision, 'leaveCollection.expectedRevision'),
        expectedMembershipVersion: integer(input.expectedMembershipVersion, 'leaveCollection.expectedMembershipVersion'),
        expectedRole: member(input.expectedRole, ['administrator', 'editor', 'viewer'], 'leaveCollection.expectedRole'),
    };
};
exports.parseLeaveCollectionRequest = parseLeaveCollectionRequest;
const parseCollectionMembershipMutationResult = (value) => {
    const input = record(value, 'collectionMembershipMutationResult');
    exactKeys(input, [
        'collectionId',
        'userId',
        'role',
        'status',
        'membershipVersion',
        'idempotent',
    ], 'collectionMembershipMutationResult');
    const collectionId = string(input.collectionId, 'collectionMembershipMutationResult.collectionId');
    const userId = string(input.userId, 'collectionMembershipMutationResult.userId');
    paths_1.firestorePaths.member(collectionId, userId);
    return {
        collectionId,
        userId,
        role: member(input.role, values_1.COLLECTION_ROLES, 'collectionMembershipMutationResult.role'),
        status: member(input.status, values_1.MEMBERSHIP_STATUSES, 'collectionMembershipMutationResult.status'),
        membershipVersion: integer(input.membershipVersion, 'collectionMembershipMutationResult.membershipVersion'),
        idempotent: boolean(input.idempotent, 'collectionMembershipMutationResult.idempotent'),
    };
};
exports.parseCollectionMembershipMutationResult = parseCollectionMembershipMutationResult;
const parseCollectionPermanentDeleteRequest = (value) => {
    const input = record(value, 'collectionPermanentDelete');
    exactKeys(input, ['collectionId', 'operationId', 'itemIds'], 'collectionPermanentDelete');
    const collectionId = string(input.collectionId, 'collectionPermanentDelete.collectionId');
    paths_1.firestorePaths.collection(collectionId);
    if (!Array.isArray(input.itemIds) ||
        input.itemIds.length === 0 ||
        input.itemIds.length > values_1.MAX_COLLECTION_BULK_ITEMS) {
        throw new Error(`collectionPermanentDelete.itemIds must contain 1 to ${values_1.MAX_COLLECTION_BULK_ITEMS} IDs.`);
    }
    const itemIds = input.itemIds.map((value, index) => {
        const id = string(value, `collectionPermanentDelete.itemIds[${index}]`);
        paths_1.firestorePaths.item(collectionId, id);
        return id;
    });
    return {
        collectionId,
        operationId: (0, paths_1.requireOperationId)(string(input.operationId, 'collectionPermanentDelete.operationId')),
        itemIds: [...new Set(itemIds)].sort(),
    };
};
exports.parseCollectionPermanentDeleteRequest = parseCollectionPermanentDeleteRequest;
const parseCollectionAuthorityRequest = (value) => {
    const input = record(value, 'collectionAuthorityRequest');
    exactKeys(input, ['collectionId'], 'collectionAuthorityRequest');
    const collectionId = string(input.collectionId, 'collectionAuthorityRequest.collectionId');
    paths_1.firestorePaths.collection(collectionId);
    return { collectionId };
};
exports.parseCollectionAuthorityRequest = parseCollectionAuthorityRequest;
const parseCollectionCapacityCapabilityRequest = (value) => {
    const input = record(value, 'collectionCapacityCapabilityRequest');
    exactKeys(input, ['collectionId', 'expectedMembershipVersion'], 'collectionCapacityCapabilityRequest');
    const collectionId = string(input.collectionId, 'collectionCapacityCapabilityRequest.collectionId');
    paths_1.firestorePaths.collection(collectionId);
    return {
        collectionId,
        expectedMembershipVersion: integer(input.expectedMembershipVersion, 'collectionCapacityCapabilityRequest.expectedMembershipVersion'),
    };
};
exports.parseCollectionCapacityCapabilityRequest = parseCollectionCapacityCapabilityRequest;
const parseCollectionCapacityCapabilityResult = (value) => {
    const input = record(value, 'collectionCapacityCapabilityResult');
    exactKeys(input, [
        'collectionId',
        'membershipVersion',
        'audience',
        'revision',
        'countedItems',
        'reservedItems',
        'effectiveLimit',
        'availableItems',
        'access',
        'additionsAllowed',
        'observedAt',
        'admissionBlockedReason',
    ], 'collectionCapacityCapabilityResult');
    const collectionId = string(input.collectionId, 'collectionCapacityCapabilityResult.collectionId');
    paths_1.firestorePaths.collection(collectionId);
    const audience = member(input.audience, ['owner', 'editor'], 'collectionCapacityCapabilityResult.audience');
    const countedItems = integer(input.countedItems, 'collectionCapacityCapabilityResult.countedItems');
    const reservedItems = integer(input.reservedItems, 'collectionCapacityCapabilityResult.reservedItems');
    const effectiveLimit = integer(input.effectiveLimit, 'collectionCapacityCapabilityResult.effectiveLimit');
    const availableItems = integer(input.availableItems, 'collectionCapacityCapabilityResult.availableItems');
    const expectedAvailable = Math.max(0, effectiveLimit - countedItems - reservedItems);
    if (availableItems !== expectedAvailable) {
        throw new Error('collectionCapacityCapabilityResult.availableItems is inconsistent.');
    }
    const access = member(input.access, values_1.CAPACITY_ACCESS_VALUES, 'collectionCapacityCapabilityResult.access');
    const additionsAllowed = boolean(input.additionsAllowed, 'collectionCapacityCapabilityResult.additionsAllowed');
    if (additionsAllowed && (access !== 'normal' || availableItems === 0)) {
        throw new Error('collectionCapacityCapabilityResult.additionsAllowed is inconsistent.');
    }
    const observedAt = timestamp(input.observedAt, 'collectionCapacityCapabilityResult.observedAt');
    const admissionBlockedReason = input.admissionBlockedReason === undefined
        ? undefined
        : member(input.admissionBlockedReason, ['debt', 'operational-limit', 'reconciliation', 'lifecycle'], 'collectionCapacityCapabilityResult.admissionBlockedReason');
    if (additionsAllowed && admissionBlockedReason)
        throw new Error('Allowed admission cannot have a blocked reason.');
    return {
        collectionId,
        membershipVersion: integer(input.membershipVersion, 'collectionCapacityCapabilityResult.membershipVersion'),
        audience,
        revision: integer(input.revision, 'collectionCapacityCapabilityResult.revision'),
        countedItems,
        reservedItems,
        effectiveLimit,
        availableItems,
        access,
        additionsAllowed,
        observedAt,
        ...(admissionBlockedReason === undefined ? {} : { admissionBlockedReason }),
    };
};
exports.parseCollectionCapacityCapabilityResult = parseCollectionCapacityCapabilityResult;
const collectionAiWorkflow = (value, label) => member(value, ['image-analysis'], label);
const collectionAiFeature = (value, label) => member(value, ['image-analysis'], label);
const parseCollectionAiCapabilityRequest = (value) => {
    const input = record(value, 'collectionAiCapabilityRequest');
    exactKeys(input, [
        'collectionId',
        'expectedMembershipVersion',
        'workflow',
        'feature',
        'imageCount',
    ], 'collectionAiCapabilityRequest');
    const collectionId = string(input.collectionId, 'collectionAiCapabilityRequest.collectionId');
    paths_1.firestorePaths.collection(collectionId);
    return {
        collectionId,
        expectedMembershipVersion: integer(input.expectedMembershipVersion, 'collectionAiCapabilityRequest.expectedMembershipVersion'),
        workflow: collectionAiWorkflow(input.workflow, 'collectionAiCapabilityRequest.workflow'),
        feature: collectionAiFeature(input.feature, 'collectionAiCapabilityRequest.feature'),
        imageCount: integer(input.imageCount, 'collectionAiCapabilityRequest.imageCount', 1),
    };
};
exports.parseCollectionAiCapabilityRequest = parseCollectionAiCapabilityRequest;
const parseCollectionAiCapabilityResult = (value) => {
    const input = record(value, 'collectionAiCapabilityResult');
    exactKeys(input, [
        'collectionId',
        'membershipVersion',
        'audience',
        'allowed',
        'reason',
        'credits',
        'costVersion',
        'headroom',
        'freeAiUses',
        'policyRevision',
        'observedAt',
    ], 'collectionAiCapabilityResult');
    const collectionId = string(input.collectionId, 'collectionAiCapabilityResult.collectionId');
    paths_1.firestorePaths.collection(collectionId);
    return {
        collectionId,
        membershipVersion: integer(input.membershipVersion, 'collectionAiCapabilityResult.membershipVersion'),
        audience: member(input.audience, ['owner', 'editor'], 'collectionAiCapabilityResult.audience'),
        allowed: boolean(input.allowed, 'collectionAiCapabilityResult.allowed'),
        reason: member(input.reason, [
            'allowed',
            'editor-disabled',
            'insufficient-credits',
            'reconciliation-required',
            'feature-unavailable',
        ], 'collectionAiCapabilityResult.reason'),
        credits: integer(input.credits, 'collectionAiCapabilityResult.credits'),
        costVersion: string(input.costVersion, 'collectionAiCapabilityResult.costVersion'),
        ...(input.freeAiUses === undefined
            ? {}
            : {
                freeAiUses: integer(input.freeAiUses, 'collectionAiCapabilityResult.freeAiUses', 0, 100),
            }),
        ...(input.headroom === undefined
            ? {}
            : {
                headroom: integer(input.headroom, 'collectionAiCapabilityResult.headroom', 0, values_1.AI_CAPABILITY_HEADROOM_CAP),
            }),
        policyRevision: integer(input.policyRevision, 'collectionAiCapabilityResult.policyRevision'),
        observedAt: timestamp(input.observedAt, 'collectionAiCapabilityResult.observedAt'),
    };
};
exports.parseCollectionAiCapabilityResult = parseCollectionAiCapabilityResult;
const parseUpdateCollectionAiPolicyRequest = (value) => {
    const input = record(value, 'updateCollectionAiPolicyRequest');
    exactKeys(input, ['collectionId', 'operationId', 'expectedRevision', 'editorAiEnabled'], 'updateCollectionAiPolicyRequest');
    const collectionId = string(input.collectionId, 'updateCollectionAiPolicyRequest.collectionId');
    paths_1.firestorePaths.collection(collectionId);
    return {
        collectionId,
        operationId: (0, paths_1.requireOperationId)(string(input.operationId, 'updateCollectionAiPolicyRequest.operationId')),
        expectedRevision: integer(input.expectedRevision, 'updateCollectionAiPolicyRequest.expectedRevision'),
        editorAiEnabled: boolean(input.editorAiEnabled, 'updateCollectionAiPolicyRequest.editorAiEnabled'),
    };
};
exports.parseUpdateCollectionAiPolicyRequest = parseUpdateCollectionAiPolicyRequest;
const parseUpdateCollectionAiPolicyResult = (value) => {
    const input = record(value, 'updateCollectionAiPolicyResult');
    exactKeys(input, ['collectionId', 'revision', 'editorAiEnabled', 'idempotent'], 'updateCollectionAiPolicyResult');
    const collectionId = string(input.collectionId, 'updateCollectionAiPolicyResult.collectionId');
    paths_1.firestorePaths.collection(collectionId);
    return {
        collectionId,
        revision: integer(input.revision, 'updateCollectionAiPolicyResult.revision'),
        editorAiEnabled: boolean(input.editorAiEnabled, 'updateCollectionAiPolicyResult.editorAiEnabled'),
        idempotent: boolean(input.idempotent, 'updateCollectionAiPolicyResult.idempotent'),
    };
};
exports.parseUpdateCollectionAiPolicyResult = parseUpdateCollectionAiPolicyResult;
const parseRunCollectionAiRequest = (value) => {
    const input = record(value, 'runCollectionAiRequest');
    exactKeys(input, [
        'collectionId',
        'expectedMembershipVersion',
        'operationId',
        'workflow',
        'feature',
        'acceptedCostVersion',
        'imageCount',
        'sourceKind',
        'sourceItemId',
        'maxCredits',
        'expectedSourceHash',
        'expectedSourceGeneration',
        'skipSavedAnalysis',
    ], 'runCollectionAiRequest');
    const collectionId = string(input.collectionId, 'runCollectionAiRequest.collectionId');
    paths_1.firestorePaths.collection(collectionId);
    const bounded = (field, maximum = 256) => {
        const result = string(input[field], `runCollectionAiRequest.${field}`);
        if (result.length > maximum)
            throw new Error(`runCollectionAiRequest.${field} is too long.`);
        return result;
    };
    const workflow = collectionAiWorkflow(input.workflow, 'runCollectionAiRequest.workflow');
    const feature = collectionAiFeature(input.feature, 'runCollectionAiRequest.feature');
    const sourceItemId = input.sourceItemId === undefined
        ? undefined
        : boundedString(input.sourceItemId, 'runCollectionAiRequest.sourceItemId', 1500);
    const sourceKind = member(input.sourceKind, ['received-bytes', 'saved-item'], 'runCollectionAiRequest.sourceKind');
    if ((sourceKind === 'saved-item') !== Boolean(sourceItemId)) {
        throw new Error('runCollectionAiRequest source or feature mapping is invalid.');
    }
    if (sourceItemId)
        paths_1.firestorePaths.item(collectionId, sourceItemId);
    return {
        collectionId,
        expectedMembershipVersion: integer(input.expectedMembershipVersion, 'runCollectionAiRequest.expectedMembershipVersion'),
        operationId: (0, paths_1.requireOperationId)(bounded('operationId')),
        workflow,
        feature,
        acceptedCostVersion: bounded('acceptedCostVersion', 128),
        imageCount: integer(input.imageCount, 'runCollectionAiRequest.imageCount', 1, 1),
        sourceKind,
        ...(sourceItemId ? { sourceItemId } : {}),
        ...(input.skipSavedAnalysis === undefined
            ? {}
            : {
                skipSavedAnalysis: boolean(input.skipSavedAnalysis, 'runCollectionAiRequest.skipSavedAnalysis'),
            }),
        ...(input.maxCredits === undefined
            ? {}
            : {
                maxCredits: integer(input.maxCredits, 'runCollectionAiRequest.maxCredits', 0, 1000000),
            }),
        ...(input.expectedSourceHash === undefined
            ? {}
            : { expectedSourceHash: bounded('expectedSourceHash') }),
        ...(input.expectedSourceGeneration === undefined
            ? {}
            : { expectedSourceGeneration: bounded('expectedSourceGeneration', 128) }),
    };
};
exports.parseRunCollectionAiRequest = parseRunCollectionAiRequest;
const parseRunCollectionAiResult = (value) => {
    const input = record(value, 'runCollectionAiResult');
    exactKeys(input, [
        'operationId',
        'workflow',
        'feature',
        'costVersion',
        'credits',
        'cacheHit',
        'sourceHash',
        'sourceGeneration',
        'extractedText',
        'keywords',
    ], 'runCollectionAiResult');
    const keywords = stringArray(input.keywords, 'runCollectionAiResult.keywords').map((keyword, index) => boundedString(keyword, `runCollectionAiResult.keywords[${index}]`, 128).trim());
    if (keywords.length > 20 || keywords.some((keyword) => !keyword))
        throw new Error('Invalid AI keywords.');
    return {
        operationId: (0, paths_1.requireOperationId)(string(input.operationId, 'runCollectionAiResult.operationId')),
        workflow: collectionAiWorkflow(input.workflow, 'runCollectionAiResult.workflow'),
        feature: collectionAiFeature(input.feature, 'runCollectionAiResult.feature'),
        costVersion: boundedString(input.costVersion, 'runCollectionAiResult.costVersion', 128),
        credits: integer(input.credits, 'runCollectionAiResult.credits'),
        cacheHit: boolean(input.cacheHit, 'runCollectionAiResult.cacheHit'),
        sourceHash: boundedString(input.sourceHash, 'runCollectionAiResult.sourceHash', 256),
        sourceGeneration: boundedString(input.sourceGeneration, 'runCollectionAiResult.sourceGeneration', 128),
        extractedText: boundedString(input.extractedText, 'runCollectionAiResult.extractedText', 8192, true),
        keywords,
    };
};
exports.parseRunCollectionAiResult = parseRunCollectionAiResult;
const parseInternalJobDocument = (value) => parseWith(value, 'internalJob', (input) => {
    const jobId = string(input.jobId, 'internalJob.jobId');
    paths_1.firestorePaths.internalJob(jobId);
    const state = member(input.state, values_1.INTERNAL_JOB_STATES, 'internalJob.state');
    const leaseId = optionalString(input.leaseId, 'internalJob.leaseId');
    const leaseExpiresAt = optionalTimestamp(input.leaseExpiresAt, 'internalJob.leaseExpiresAt');
    if (state === 'leased' && !leaseExpiresAt) {
        throw new Error('Leased internal jobs require a lease expiry.');
    }
    if (state !== 'leased' && (leaseId || leaseExpiresAt)) {
        throw new Error('Only leased internal jobs may retain lease identity or expiry.');
    }
    return {
        jobId,
        authorityId: string(input.authorityId, 'internalJob.authorityId'),
        workflow: (0, paths_1.requireWorkflow)(string(input.workflow, 'internalJob.workflow')),
        operationId: operationId(input.operationId, 'internalJob.operationId'),
        state,
        ...(leaseId === undefined ? {} : { leaseId }),
        ...(leaseExpiresAt === undefined ? {} : { leaseExpiresAt }),
        ...(input.notBefore === undefined
            ? {}
            : { notBefore: timestamp(input.notBefore, 'internalJob.notBefore') }),
        attempts: integer(input.attempts, 'internalJob.attempts'),
        ...(input.checkpoint === undefined
            ? {}
            : { checkpoint: string(input.checkpoint, 'internalJob.checkpoint') }),
        ...(input.lastErrorCode === undefined
            ? {}
            : {
                lastErrorCode: string(input.lastErrorCode, 'internalJob.lastErrorCode'),
            }),
        ...(input.lastRecoveryOperationId === undefined
            ? {}
            : {
                lastRecoveryOperationId: operationId(input.lastRecoveryOperationId, 'internalJob.lastRecoveryOperationId'),
            }),
    };
});
exports.parseInternalJobDocument = parseInternalJobDocument;
const parseInternalJobTaskRequest = (value) => {
    const input = record(value, 'internalJobTask');
    exactKeys(input, ['jobId', 'dispatchRevision'], 'internalJobTask');
    const jobId = string(input.jobId, 'internalJobTask.jobId');
    paths_1.firestorePaths.internalJob(jobId);
    return {
        jobId,
        dispatchRevision: integer(input.dispatchRevision, 'internalJobTask.dispatchRevision'),
    };
};
exports.parseInternalJobTaskRequest = parseInternalJobTaskRequest;
const parseCollectionImageDeletionFenceDocument = (value) => parseWith(value, 'collectionImageDeletionFence', (input) => {
    const fenceId = operationId(input.fenceId, 'collectionImageDeletionFence.fenceId');
    const collectionId = string(input.collectionId, 'collectionImageDeletionFence.collectionId');
    paths_1.firestorePaths.imageDeletionFence(collectionId);
    const actorUserId = string(input.actorUserId, 'collectionImageDeletionFence.actorUserId');
    const state = member(input.state, ['preparing', 'deleting'], 'collectionImageDeletionFence.state');
    const paths = stringArray(input.paths, 'collectionImageDeletionFence.paths');
    if (paths.length === 0 ||
        paths.length > 100 ||
        new Set(paths).size !== paths.length) {
        throw new Error('collectionImageDeletionFence.paths must contain 1 to 100 unique paths.');
    }
    paths.forEach((path, index) => {
        const prefix = `${paths_1.firestorePaths.collection(collectionId)}/images/`;
        if (!path.startsWith(prefix)) {
            throw new Error(`collectionImageDeletionFence.paths[${index}] is invalid.`);
        }
        const name = path.slice(prefix.length);
        if (paths_1.storagePaths.durableImage(collectionId, name) !== path) {
            throw new Error(`collectionImageDeletionFence.paths[${index}] is invalid.`);
        }
    });
    let images;
    if (input.images !== undefined) {
        if (!Array.isArray(input.images)) {
            throw new Error('collectionImageDeletionFence.images must be an array.');
        }
        images = input.images.map((value, index) => {
            const image = record(value, `collectionImageDeletionFence.images[${index}]`);
            const path = string(image.path, `collectionImageDeletionFence.images[${index}].path`);
            const missing = boolean(image.missing, `collectionImageDeletionFence.images[${index}].missing`);
            const generation = image.generation === undefined
                ? undefined
                : integer(image.generation, `collectionImageDeletionFence.images[${index}].generation`);
            if (path !== paths[index] ||
                (missing && generation !== undefined) ||
                (!missing && generation === undefined)) {
                throw new Error(`collectionImageDeletionFence.images[${index}] is inconsistent.`);
            }
            return {
                path,
                missing,
                ...(generation === undefined ? {} : { generation }),
            };
        });
    }
    if ((state === 'preparing' && images !== undefined) ||
        (state === 'deleting' && (images === null || images === void 0 ? void 0 : images.length) !== paths.length)) {
        throw new Error('collectionImageDeletionFence state and manifest are inconsistent.');
    }
    const leaseId = operationId(input.leaseId, 'collectionImageDeletionFence.leaseId');
    const leaseExpiresAt = timestamp(input.leaseExpiresAt, 'collectionImageDeletionFence.leaseExpiresAt');
    const createdAt = timestamp(input.createdAt, 'collectionImageDeletionFence.createdAt');
    const updatedAt = timestamp(input.updatedAt, 'collectionImageDeletionFence.updatedAt');
    if (compareTimestamps(createdAt, updatedAt) > 0 ||
        compareTimestamps(updatedAt, leaseExpiresAt) > 0) {
        throw new Error('collectionImageDeletionFence timestamps are inconsistent.');
    }
    return {
        fenceId,
        collectionId,
        actorUserId,
        state,
        paths,
        ...(images === undefined ? {} : { images }),
        leaseId,
        leaseExpiresAt,
        createdAt,
        updatedAt,
    };
});
exports.parseCollectionImageDeletionFenceDocument = parseCollectionImageDeletionFenceDocument;
const parseStripeCustomerMappingDocument = (value) => parseWith(value, 'stripeCustomerMapping', (input) => ({
    stripeCustomerId: string(input.stripeCustomerId, 'stripeCustomerMapping.stripeCustomerId'),
    billingAccountId: string(input.billingAccountId, 'stripeCustomerMapping.billingAccountId'),
    ...(input.environment === undefined
        ? {}
        : {
            environment: member(input.environment, ['test', 'live'], 'stripeCustomerMapping.environment'),
        }),
    createdAt: timestamp(input.createdAt, 'stripeCustomerMapping.createdAt'),
}));
exports.parseStripeCustomerMappingDocument = parseStripeCustomerMappingDocument;
const parseStripeWebhookClaimDocument = (value) => parseWith(value, 'stripeWebhookClaim', (input) => ({
    stripeEventId: string(input.stripeEventId, 'stripeWebhookClaim.stripeEventId'),
    ...(input.environment === undefined
        ? {}
        : {
            environment: member(input.environment, ['test', 'live'], 'stripeWebhookClaim.environment'),
        }),
    eventType: optionalString(input.eventType, 'stripeWebhookClaim.eventType'),
    state: member(input.state, ['processing', 'completed', 'retryable', 'dead-letter'], 'stripeWebhookClaim.state'),
    ...(input.leaseId === undefined
        ? {}
        : {
            leaseId: operationId(input.leaseId, 'stripeWebhookClaim.leaseId'),
        }),
    leaseExpiresAt: optionalTimestamp(input.leaseExpiresAt, 'stripeWebhookClaim.leaseExpiresAt'),
    attempts: integer(input.attempts, 'stripeWebhookClaim.attempts'),
    lastErrorCode: optionalString(input.lastErrorCode, 'stripeWebhookClaim.lastErrorCode'),
    ...(input.recoveryId === undefined
        ? {}
        : {
            recoveryId: operationId(input.recoveryId, 'stripeWebhookClaim.recoveryId'),
        }),
    ...(input.recoveredFromRevision === undefined
        ? {}
        : {
            recoveredFromRevision: integer(input.recoveredFromRevision, 'stripeWebhookClaim.recoveredFromRevision'),
        }),
    createdAt: optionalTimestamp(input.createdAt, 'stripeWebhookClaim.createdAt'),
    updatedAt: optionalTimestamp(input.updatedAt, 'stripeWebhookClaim.updatedAt'),
    completedAt: optionalTimestamp(input.completedAt, 'stripeWebhookClaim.completedAt'),
}));
exports.parseStripeWebhookClaimDocument = parseStripeWebhookClaimDocument;
const parseCreditBalanceDocument = (value) => {
    const input = record(value, 'creditBalance');
    exactKeys(input, [
        'schemaVersion',
        'revision',
        'billingAccountId',
        'balance',
        'reconciliationRequired',
    ], 'creditBalance');
    if (input.schemaVersion !== 4)
        throw new Error('Credit balance schema is unsupported.');
    paths_1.firestorePaths.billingAccount(string(input.billingAccountId, 'creditBalance.billingAccountId'));
    return {
        schemaVersion: 4,
        revision: integer(input.revision, 'creditBalance.revision'),
        billingAccountId: string(input.billingAccountId, 'creditBalance.billingAccountId'),
        balance: signedInteger(input.balance, 'creditBalance.balance'),
        ...(input.reconciliationRequired === undefined
            ? {}
            : {
                reconciliationRequired: boolean(input.reconciliationRequired, 'creditBalance.reconciliationRequired'),
            }),
    };
};
exports.parseCreditBalanceDocument = parseCreditBalanceDocument;
const parseAiAllowanceDocument = (value) => parseWith(value, 'aiAllowance', (input) => {
    exactKeys(input, [
        'schemaVersion',
        'revision',
        'billingAccountId',
        'grantedUses',
        'remainingUses',
        'grantedAt',
        'grantVersion',
    ], 'aiAllowance');
    const billingAccountId = string(input.billingAccountId, 'aiAllowance.billingAccountId');
    paths_1.firestorePaths.aiAllowance(billingAccountId);
    return {
        billingAccountId,
        grantedUses: integer(input.grantedUses, 'aiAllowance.grantedUses', 100, 100),
        remainingUses: integer(input.remainingUses, 'aiAllowance.remainingUses', 0, 100),
        grantedAt: timestamp(input.grantedAt, 'aiAllowance.grantedAt'),
        grantVersion: member(input.grantVersion, ['signup-ai-v1'], 'aiAllowance.grantVersion'),
    };
});
exports.parseAiAllowanceDocument = parseAiAllowanceDocument;
const parseAiUsageOperationDocument = (value) => parseWith(value, 'aiUsageOperation', (input) => {
    const state = member(input.state, [
        'queued',
        'dispatching',
        'dispatched',
        'dispatch-unknown',
        'completed',
        'refunded',
    ], 'aiUsageOperation.state');
    const dispatchAttemptId = optionalString(input.dispatchAttemptId, 'aiUsageOperation.dispatchAttemptId');
    const providerRequestId = optionalString(input.providerRequestId, 'aiUsageOperation.providerRequestId');
    if ((state === 'queued' && (dispatchAttemptId || providerRequestId)) ||
        ((state === 'dispatching' || state === 'dispatch-unknown') &&
            (!dispatchAttemptId || providerRequestId)) ||
        ((state === 'dispatched' || state === 'completed') &&
            (!dispatchAttemptId || !providerRequestId)))
        throw new Error('aiUsageOperation dispatch evidence and state are incoherent.');
    return {
        operationId: operationId(input.operationId, 'aiUsageOperation.operationId'),
        billingAccountId: string(input.billingAccountId, 'aiUsageOperation.billingAccountId'),
        collectionId: string(input.collectionId, 'aiUsageOperation.collectionId'),
        actorUserId: string(input.actorUserId, 'aiUsageOperation.actorUserId'),
        workflow: member(input.workflow, ['image-analysis'], 'aiUsageOperation.workflow'),
        feature: member(input.feature, ['image-analysis'], 'aiUsageOperation.feature'),
        imageCount: integer(input.imageCount, 'aiUsageOperation.imageCount', 1, values_1.MAX_AI_CREDITS_PER_OPERATION),
        credits: integer(input.credits, 'aiUsageOperation.credits', 1, values_1.MAX_AI_CREDITS_PER_OPERATION),
        ...(input.freeUses === undefined
            ? {}
            : {
                freeUses: integer(input.freeUses, 'aiUsageOperation.freeUses', 0, Math.min(Number(input.imageCount), Number(input.credits), 100)),
            }),
        costVersion: string(input.costVersion, 'aiUsageOperation.costVersion'),
        state,
        dispatchAttemptId,
        providerRequestId,
        ...(input.providerFailed === undefined
            ? {}
            : {
                providerFailed: boolean(input.providerFailed, 'aiUsageOperation.providerFailed'),
            }),
        createdAt: timestamp(input.createdAt, 'aiUsageOperation.createdAt'),
        updatedAt: timestamp(input.updatedAt, 'aiUsageOperation.updatedAt'),
    };
});
exports.parseAiUsageOperationDocument = parseAiUsageOperationDocument;
const parseCreditTransactionDocument = (value) => parseWith(value, 'creditTransaction', (input) => {
    exactKeys(input, [
        'schemaVersion',
        'revision',
        'eventId',
        'billingAccountId',
        'operationId',
        'eventType',
        'amount',
        'collectionId',
        'purchaseId',
        'actorUserId',
        'shortfallCredits',
        'createdAt',
        'periodStart',
        'periodEnd',
        'peakItems',
        'pricingVersion',
    ], 'creditTransaction');
    if (input.revision !== 0 || !Number.isSafeInteger(input.amount))
        throw new Error('Invalid credit transaction.');
    const eventType = member(input.eventType, [
        'grant',
        'ai-charge',
        'ai-refund',
        'reversal',
        'adjustment',
        'monthly-item-charge',
    ], 'creditTransaction.eventType');
    const amount = Number(input.amount);
    paths_1.firestorePaths.creditTransaction(string(input.billingAccountId, 'creditTransaction.billingAccountId'), string(input.eventId, 'creditTransaction.eventId'));
    if ((['grant', 'ai-refund'].includes(eventType) && amount <= 0) ||
        (['ai-charge', 'monthly-item-charge'].includes(eventType) &&
            amount >= 0) ||
        (eventType === 'reversal' && amount > 0))
        throw new Error('Invalid credit transaction direction.');
    let monthlyEvidence = {};
    if (eventType === 'monthly-item-charge') {
        const periodStart = timestamp(input.periodStart, 'creditTransaction.periodStart');
        const periodEnd = timestamp(input.periodEnd, 'creditTransaction.periodEnd');
        const peakItems = integer(input.peakItems, 'creditTransaction.peakItems');
        if (periodStart.nanoseconds !== 0 ||
            periodEnd.nanoseconds !== 0 ||
            periodStart.seconds >= periodEnd.seconds ||
            amount !== -(0, accountItemBilling_1.monthlyItemCredits)(peakItems) ||
            input.pricingVersion !== accountItemBilling_1.ITEM_BILLING_PRICING_VERSION)
            throw new Error('Invalid monthly billing evidence.');
        monthlyEvidence = {
            periodStart,
            periodEnd,
            peakItems,
            pricingVersion: accountItemBilling_1.ITEM_BILLING_PRICING_VERSION,
        };
    }
    else if (['periodStart', 'periodEnd', 'peakItems', 'pricingVersion'].some((key) => input[key] !== undefined))
        throw new Error('Unexpected monthly billing evidence.');
    return {
        ...monthlyEvidence,
        eventId: string(input.eventId, 'creditTransaction.eventId'),
        billingAccountId: string(input.billingAccountId, 'creditTransaction.billingAccountId'),
        operationId: operationId(input.operationId, 'creditTransaction.operationId'),
        eventType,
        amount,
        ...(input.collectionId === undefined
            ? {}
            : {
                collectionId: string(input.collectionId, 'creditTransaction.collectionId'),
            }),
        ...(input.purchaseId === undefined
            ? {}
            : {
                purchaseId: string(input.purchaseId, 'creditTransaction.purchaseId'),
            }),
        ...(input.actorUserId === undefined
            ? {}
            : {
                actorUserId: string(input.actorUserId, 'creditTransaction.actorUserId'),
            }),
        ...(input.shortfallCredits === undefined
            ? {}
            : {
                shortfallCredits: integer(input.shortfallCredits, 'creditTransaction.shortfallCredits'),
            }),
        createdAt: timestamp(input.createdAt, 'creditTransaction.createdAt'),
    };
});
exports.parseCreditTransactionDocument = parseCreditTransactionDocument;
const parseAiCreditPurchaseDocument = (value) => {
    const input = record(value, 'aiCreditPurchase');
    if (input.schemaVersion !== 2)
        throw new Error('aiCreditPurchase.schemaVersion is unsupported.');
    const terms = record(input.terms, 'aiCreditPurchase.terms');
    exactKeys(terms, ['credits', 'amountMinor', 'currency', 'stripePriceId', 'environment'], 'aiCreditPurchase.terms');
    const stripePriceId = string(terms.stripePriceId, 'aiCreditPurchase.terms.stripePriceId');
    if (!/^price_[A-Za-z0-9_]+$/.test(stripePriceId))
        throw new Error('Invalid purchase Stripe price ID.');
    return {
        schemaVersion: 2,
        revision: integer(input.revision, 'aiCreditPurchase.revision'),
        terms: {
            credits: integer(terms.credits, 'aiCreditPurchase.terms.credits', 1, 1000000),
            amountMinor: integer(terms.amountMinor, 'aiCreditPurchase.terms.amountMinor', 1),
            currency: member(terms.currency, ['NZD'], 'aiCreditPurchase.terms.currency'),
            environment: member(terms.environment, ['test', 'live'], 'aiCreditPurchase.terms.environment'),
            stripePriceId,
        },
        purchaseId: string(input.purchaseId, 'aiCreditPurchase.purchaseId'),
        operationId: operationId(input.operationId, 'aiCreditPurchase.operationId'),
        billingAccountId: string(input.billingAccountId, 'aiCreditPurchase.billingAccountId'),
        packKey: string(input.packKey, 'aiCreditPurchase.packKey'),
        catalogueVersion: string(input.catalogueVersion, 'aiCreditPurchase.catalogueVersion'),
        stripeCheckoutSessionId: optionalString(input.stripeCheckoutSessionId, 'aiCreditPurchase.stripeCheckoutSessionId'),
        stripePaymentReference: optionalString(input.stripePaymentReference, 'aiCreditPurchase.stripePaymentReference'),
        state: member(input.state, [
            'pending',
            'settling',
            'paid',
            'refunded',
            'disputed',
            'reconcile',
        ], 'aiCreditPurchase.state'),
        createdAt: timestamp(input.createdAt, 'aiCreditPurchase.createdAt'),
        updatedAt: timestamp(input.updatedAt, 'aiCreditPurchase.updatedAt'),
    };
};
exports.parseAiCreditPurchaseDocument = parseAiCreditPurchaseDocument;
const parseCreateAiCreditCheckoutRequest = (value) => {
    const input = record(value, 'createAiCreditCheckoutRequest');
    exactKeys(input, ['operationId', 'packKey'], 'createAiCreditCheckoutRequest');
    return {
        operationId: (0, paths_1.requireOperationId)(string(input.operationId, 'createAiCreditCheckoutRequest.operationId')),
        packKey: member(input.packKey, ['starter-1000-v1', 'regular-3000-v1', 'bulk-10000-v1'], 'createAiCreditCheckoutRequest.packKey'),
    };
};
exports.parseCreateAiCreditCheckoutRequest = parseCreateAiCreditCheckoutRequest;
const parseCreateAiCreditCheckoutResult = (value) => {
    const input = record(value, 'createAiCreditCheckoutResult');
    exactKeys(input, ['operationId', 'purchaseId', 'hostedUrl', 'expiresAt', 'idempotent'], 'createAiCreditCheckoutResult');
    const hostedUrl = string(input.hostedUrl, 'createAiCreditCheckoutResult.hostedUrl');
    let parsedUrl;
    try {
        parsedUrl = new URL(hostedUrl);
    }
    catch {
        throw new Error('Invalid hosted Checkout URL.');
    }
    if (parsedUrl.protocol !== 'https:' ||
        parsedUrl.username ||
        parsedUrl.password) {
        throw new Error('Invalid hosted Checkout URL.');
    }
    if (!['checkout.stripe.com', 'checkout.stripe.test'].includes(parsedUrl.hostname.toLowerCase())) {
        throw new Error('Invalid hosted Checkout URL origin.');
    }
    return {
        operationId: (0, paths_1.requireOperationId)(string(input.operationId, 'createAiCreditCheckoutResult.operationId')),
        purchaseId: string(input.purchaseId, 'createAiCreditCheckoutResult.purchaseId'),
        hostedUrl,
        expiresAt: timestamp(input.expiresAt, 'createAiCreditCheckoutResult.expiresAt'),
        idempotent: boolean(input.idempotent, 'createAiCreditCheckoutResult.idempotent'),
    };
};
exports.parseCreateAiCreditCheckoutResult = parseCreateAiCreditCheckoutResult;
const parseAiCreditHistoryRequestWithLabel = (value, label) => {
    const input = value === undefined ? {} : record(value, label);
    exactKeys(input, ['pageSize', 'cursor'], label);
    return {
        ...(input.pageSize === undefined
            ? {}
            : {
                pageSize: integer(input.pageSize, `${label}.pageSize`, 1, 25),
            }),
        ...(input.cursor === undefined
            ? {}
            : {
                cursor: boundedString(input.cursor, `${label}.cursor`, 512),
            }),
    };
};
const parseAiCreditHistoryRequest = (value) => parseAiCreditHistoryRequestWithLabel(value, 'aiCreditHistoryRequest');
exports.parseAiCreditHistoryRequest = parseAiCreditHistoryRequest;
const parseAiCreditPurchaseSummary = (value) => {
    const input = record(value, 'aiCreditPurchaseSummary');
    exactKeys(input, ['purchaseId', 'packKey', 'state', 'createdAt', 'updatedAt'], 'aiCreditPurchaseSummary');
    return {
        purchaseId: string(input.purchaseId, 'aiCreditPurchaseSummary.purchaseId'),
        packKey: member(input.packKey, ['starter-1000-v1', 'regular-3000-v1', 'bulk-10000-v1'], 'aiCreditPurchaseSummary.packKey'),
        state: member(input.state, [
            'pending',
            'settling',
            'paid',
            'refunded',
            'disputed',
            'reconcile',
        ], 'aiCreditPurchaseSummary.state'),
        createdAt: isoInstant(input.createdAt, 'aiCreditPurchaseSummary.createdAt'),
        updatedAt: isoInstant(input.updatedAt, 'aiCreditPurchaseSummary.updatedAt'),
    };
};
const parseAiCreditPurchaseHistoryResult = (value) => {
    const input = record(value, 'aiCreditPurchaseHistoryResult');
    exactKeys(input, ['items', 'nextCursor'], 'aiCreditPurchaseHistoryResult');
    if (!Array.isArray(input.items) || input.items.length > 25)
        throw new Error('aiCreditPurchaseHistoryResult.items is invalid.');
    return {
        items: input.items.map(parseAiCreditPurchaseSummary),
        ...(input.nextCursor === undefined
            ? {}
            : {
                nextCursor: boundedString(input.nextCursor, 'aiCreditPurchaseHistoryResult.nextCursor', 512),
            }),
    };
};
exports.parseAiCreditPurchaseHistoryResult = parseAiCreditPurchaseHistoryResult;
const parseAiCreditUsageSummary = (value) => {
    const input = record(value, 'aiCreditUsageSummary');
    exactKeys(input, [
        'collectionId',
        'actorUserId',
        'workflow',
        'feature',
        'imageCount',
        'credits',
        'state',
        'createdAt',
        'updatedAt',
    ], 'aiCreditUsageSummary');
    return {
        collectionId: string(input.collectionId, 'aiCreditUsageSummary.collectionId'),
        actorUserId: string(input.actorUserId, 'aiCreditUsageSummary.actorUserId'),
        workflow: member(input.workflow, ['image-analysis'], 'aiCreditUsageSummary.workflow'),
        feature: member(input.feature, ['image-analysis'], 'aiCreditUsageSummary.feature'),
        imageCount: integer(input.imageCount, 'aiCreditUsageSummary.imageCount', 1),
        credits: integer(input.credits, 'aiCreditUsageSummary.credits', 0),
        state: member(input.state, [
            'queued',
            'dispatching',
            'dispatched',
            'dispatch-unknown',
            'completed',
            'refunded',
        ], 'aiCreditUsageSummary.state'),
        createdAt: isoInstant(input.createdAt, 'aiCreditUsageSummary.createdAt'),
        updatedAt: isoInstant(input.updatedAt, 'aiCreditUsageSummary.updatedAt'),
    };
};
const parseAiCreditUsageHistoryResult = (value) => {
    const input = record(value, 'aiCreditUsageHistoryResult');
    exactKeys(input, ['items', 'nextCursor'], 'aiCreditUsageHistoryResult');
    if (!Array.isArray(input.items) || input.items.length > 25)
        throw new Error('aiCreditUsageHistoryResult.items is invalid.');
    return {
        items: input.items.map(parseAiCreditUsageSummary),
        ...(input.nextCursor === undefined
            ? {}
            : {
                nextCursor: boundedString(input.nextCursor, 'aiCreditUsageHistoryResult.nextCursor', 512),
            }),
    };
};
exports.parseAiCreditUsageHistoryResult = parseAiCreditUsageHistoryResult;
const parseCreditTransactionHistoryResult = (value) => {
    const input = record(value, 'creditTransactionHistory');
    exactKeys(input, ['items', 'nextCursor'], 'creditTransactionHistory');
    if (!Array.isArray(input.items) || input.items.length > 25)
        throw new Error('Invalid transaction history.');
    const items = input.items.map((raw) => {
        const entry = record(raw, 'creditTransactionHistoryEntry');
        const id = string(entry.id, 'transaction.id');
        const amount = signedInteger(entry.amount, 'transaction.amount');
        const createdAt = isoInstant(entry.createdAt, 'transaction.createdAt');
        if (entry.reason === 'ai-charge') {
            exactKeys(entry, ['id', 'amount', 'reason', 'createdAt', 'day', 'chargeCount'], 'dailyAiCharges');
            const day = string(entry.day, 'dailyAiCharges.day');
            const chargeCount = integer(entry.chargeCount, 'dailyAiCharges.chargeCount', 1);
            if (!/^\d{4}-\d{2}-\d{2}$/.test(day) ||
                createdAt !== `${day}T00:00:00.000Z` ||
                id !== `ai-day-${day}` ||
                amount >= 0 ||
                -amount < chargeCount)
                throw new Error('Invalid daily AI charges.');
            return { id, amount, createdAt, reason: 'ai-charge', day, chargeCount };
        }
        exactKeys(entry, ['id', 'amount', 'reason', 'createdAt', 'purchaseId'], 'individualCreditTransaction');
        return {
            id,
            amount,
            createdAt,
            reason: member(entry.reason, [
                'grant',
                'ai-refund',
                'reversal',
                'adjustment',
                'monthly-item-charge',
            ], 'transaction.reason'),
            ...(entry.purchaseId === undefined
                ? {}
                : { purchaseId: string(entry.purchaseId, 'transaction.purchaseId') }),
        };
    });
    return {
        items,
        ...(input.nextCursor === undefined
            ? {}
            : {
                nextCursor: boundedString(input.nextCursor, 'transaction.nextCursor', 512),
            }),
    };
};
exports.parseCreditTransactionHistoryResult = parseCreditTransactionHistoryResult;
const parseAiCreditWalletSummaryResult = (value) => {
    const input = record(value, 'aiCreditWalletSummaryResult');
    exactKeys(input, [
        'balance',
        'reconciliationRequired',
        'purchasingAvailable',
        'catalogueVersion',
        'packs',
        'recentTransactions',
    ], 'aiCreditWalletSummaryResult');
    if (!Array.isArray(input.packs) || input.packs.length > 3)
        throw new Error('aiCreditWalletSummaryResult.packs is invalid.');
    if (!Array.isArray(input.recentTransactions) ||
        input.recentTransactions.length > 10)
        throw new Error('Invalid recent transactions.');
    return {
        recentTransactions: input.recentTransactions.map((raw) => {
            const entry = record(raw, 'creditTransactionSummary');
            exactKeys(entry, ['id', 'amount', 'reason', 'createdAt'], 'creditTransactionSummary');
            return {
                id: string(entry.id, 'creditTransactionSummary.id'),
                amount: signedInteger(entry.amount, 'creditTransactionSummary.amount'),
                reason: member(entry.reason, [
                    'grant',
                    'ai-charge',
                    'ai-refund',
                    'reversal',
                    'adjustment',
                    'monthly-item-charge',
                ], 'creditTransactionSummary.reason'),
                createdAt: isoInstant(entry.createdAt, 'creditTransactionSummary.createdAt'),
            };
        }),
        balance: signedInteger(input.balance, 'aiCreditWalletSummaryResult.balance'),
        reconciliationRequired: boolean(input.reconciliationRequired, 'aiCreditWalletSummaryResult.reconciliationRequired'),
        purchasingAvailable: boolean(input.purchasingAvailable, 'aiCreditWalletSummaryResult.purchasingAvailable'),
        catalogueVersion: string(input.catalogueVersion, 'aiCreditWalletSummaryResult.catalogueVersion'),
        packs: input.packs.map((value) => {
            const pack = record(value, 'aiCreditPackSummary');
            exactKeys(pack, ['packKey', 'credits', 'amountMinor', 'currency', 'taxBehavior'], 'aiCreditPackSummary');
            return {
                packKey: member(pack.packKey, ['starter-1000-v1', 'regular-3000-v1', 'bulk-10000-v1'], 'aiCreditPackSummary.packKey'),
                credits: integer(pack.credits, 'aiCreditPackSummary.credits', 1),
                amountMinor: integer(pack.amountMinor, 'aiCreditPackSummary.amountMinor', 1),
                currency: member(pack.currency, ['NZD'], 'aiCreditPackSummary.currency'),
                taxBehavior: member(pack.taxBehavior, ['inclusive', 'exclusive'], 'aiCreditPackSummary.taxBehavior'),
            };
        }),
    };
};
exports.parseAiCreditWalletSummaryResult = parseAiCreditWalletSummaryResult;
const parseBillingSummaryRequest = (value) => {
    const input = record(value, 'billingSummaryRequest');
    exactKeys(input, [], 'billingSummaryRequest');
    return {};
};
exports.parseBillingSummaryRequest = parseBillingSummaryRequest;
const parseBillingSummaryResult = (value) => {
    const input = record(value, 'billingSummaryResult');
    exactKeys(input, [
        'contractVersion',
        'accountType',
        'owner',
        'currency',
        'dormant',
        'reconciliationPending',
        'aiCredits',
        'freeAiUses',
        'itemBilling',
    ], 'billingSummaryResult');
    const credits = record(input.aiCredits, 'billingSummaryResult.aiCredits');
    exactKeys(credits, ['available'], 'billingSummaryResult.aiCredits');
    const billing = record(input.itemBilling, 'billingSummaryResult.itemBilling');
    exactKeys(billing, [
        'currentItems',
        'peakItems',
        'freeItems',
        'billableItems',
        'projectedCredits',
        'periodStart',
        'periodEnd',
        'restricted',
    ], 'billingSummaryResult.itemBilling');
    const currentItems = integer(billing.currentItems, 'itemBilling.currentItems');
    const peakItems = integer(billing.peakItems, 'itemBilling.peakItems', currentItems);
    const freeItems = integer(billing.freeItems, 'itemBilling.freeItems', accountItemBilling_1.FREE_ITEM_ALLOWANCE, accountItemBilling_1.FREE_ITEM_ALLOWANCE);
    const billableItems = integer(billing.billableItems, 'itemBilling.billableItems');
    const projectedCredits = integer(billing.projectedCredits, 'itemBilling.projectedCredits');
    const available = signedInteger(credits.available, 'billingSummaryResult.aiCredits.available');
    const periodStart = isoInstant(billing.periodStart, 'itemBilling.periodStart');
    const periodEnd = isoInstant(billing.periodEnd, 'itemBilling.periodEnd');
    const restricted = boolean(billing.restricted, 'itemBilling.restricted');
    if (billableItems !== Math.max(0, peakItems - freeItems) ||
        projectedCredits !== (0, accountItemBilling_1.monthlyItemCredits)(peakItems) ||
        Date.parse(periodStart) >= Date.parse(periodEnd) ||
        restricted !== available < 0)
        throw new Error('Inconsistent item billing summary.');
    return {
        contractVersion: member(input.contractVersion, ['collections-billing-v45'], 'billingSummaryResult.contractVersion'),
        accountType: member(input.accountType, ['personal'], 'billingSummaryResult.accountType'),
        owner: input.owner === true
            ? true
            : (() => {
                throw new Error('Owner billing summary required.');
            })(),
        currency: member(input.currency, ['NZD'], 'billingSummaryResult.currency'),
        dormant: boolean(input.dormant, 'billingSummaryResult.dormant'),
        reconciliationPending: boolean(input.reconciliationPending, 'billingSummaryResult.reconciliationPending'),
        freeAiUses: integer(input.freeAiUses, 'billingSummaryResult.freeAiUses', 0, 100),
        aiCredits: { available },
        itemBilling: {
            currentItems,
            peakItems,
            freeItems,
            billableItems,
            projectedCredits,
            periodStart,
            periodEnd,
            restricted,
        },
    };
};
exports.parseBillingSummaryResult = parseBillingSummaryResult;
exports.USERNAME_REGEX = /^[a-zA-Z0-9_-]{3,20}$/;
const parseUsername = (value, label = 'username') => {
    const val = string(value, label).trim();
    if (!exports.USERNAME_REGEX.test(val)) {
        throw new Error(`Invalid ${label}: must be 3-20 characters long and contain only letters, numbers, underscores, or hyphens.`);
    }
    return val;
};
exports.parseUsername = parseUsername;
const parseUsernameClaimDocument = (value) => {
    const input = record(value, 'usernameClaim');
    exactKeys(input, ['userId', 'username', 'createdAt'], 'usernameClaim');
    return {
        userId: string(input.userId, 'usernameClaim.userId'),
        username: (0, exports.parseUsername)(input.username, 'usernameClaim.username'),
        createdAt: timestamp(input.createdAt, 'usernameClaim.createdAt'),
    };
};
exports.parseUsernameClaimDocument = parseUsernameClaimDocument;
const parseChangeUsernameRequest = (value) => {
    const input = record(value, 'changeUsername');
    exactKeys(input, ['username'], 'changeUsername');
    return { username: (0, exports.parseUsername)(input.username, 'changeUsername.username') };
};
exports.parseChangeUsernameRequest = parseChangeUsernameRequest;
const parseCheckUsernameAvailabilityRequest = (value) => {
    const input = record(value, 'checkUsernameAvailability');
    exactKeys(input, ['username'], 'checkUsernameAvailability');
    return {
        username: (0, exports.parseUsername)(input.username, 'checkUsernameAvailability.username'),
    };
};
exports.parseCheckUsernameAvailabilityRequest = parseCheckUsernameAvailabilityRequest;
const parseResolveCollectionUsernameRequest = (value) => {
    const input = record(value, 'resolveCollectionUsername');
    exactKeys(input, ['collectionId', 'targetUserId', 'expectedMembershipVersion'], 'resolveCollectionUsername');
    const collectionId = string(input.collectionId, 'resolveCollectionUsername.collectionId');
    paths_1.firestorePaths.collection(collectionId);
    const targetUserId = string(input.targetUserId, 'resolveCollectionUsername.targetUserId');
    paths_1.firestorePaths.member(collectionId, targetUserId);
    return {
        collectionId,
        targetUserId,
        expectedMembershipVersion: integer(input.expectedMembershipVersion, 'resolveCollectionUsername.expectedMembershipVersion'),
    };
};
exports.parseResolveCollectionUsernameRequest = parseResolveCollectionUsernameRequest;
const parseChangeUsernameResult = (value) => {
    const input = record(value, 'changeUsernameResult');
    exactKeys(input, ['username', 'normalizedUsername', 'changed', 'usernameUpdatedAt'], 'changeUsernameResult');
    const username = (0, exports.parseUsername)(input.username, 'changeUsernameResult.username');
    const normalizedUsername = (0, exports.parseUsername)(input.normalizedUsername, 'changeUsernameResult.normalizedUsername');
    if (normalizedUsername !== normalizedUsername.toLowerCase()) {
        throw new Error('changeUsernameResult.normalizedUsername must be canonical lowercase.');
    }
    if (normalizedUsername !== username.toLowerCase()) {
        throw new Error('changeUsernameResult.normalizedUsername must match username.');
    }
    return {
        username,
        normalizedUsername,
        changed: boolean(input.changed, 'changeUsernameResult.changed'),
        usernameUpdatedAt: timestamp(input.usernameUpdatedAt, 'changeUsernameResult.usernameUpdatedAt'),
    };
};
exports.parseChangeUsernameResult = parseChangeUsernameResult;
const parseCheckUsernameAvailabilityResult = (value) => {
    const input = record(value, 'checkUsernameAvailabilityResult');
    exactKeys(input, ['available'], 'checkUsernameAvailabilityResult');
    return {
        available: boolean(input.available, 'checkUsernameAvailabilityResult.available'),
    };
};
exports.parseCheckUsernameAvailabilityResult = parseCheckUsernameAvailabilityResult;
const parseResolveCollectionUsernameResult = (value) => {
    const input = record(value, 'resolveCollectionUsernameResult');
    exactKeys(input, ['collectionId', 'targetUserId', 'membershipVersion', 'username'], 'resolveCollectionUsernameResult');
    const collectionId = string(input.collectionId, 'resolveCollectionUsernameResult.collectionId');
    paths_1.firestorePaths.collection(collectionId);
    const targetUserId = string(input.targetUserId, 'resolveCollectionUsernameResult.targetUserId');
    paths_1.firestorePaths.member(collectionId, targetUserId);
    return {
        collectionId,
        targetUserId,
        membershipVersion: integer(input.membershipVersion, 'resolveCollectionUsernameResult.membershipVersion'),
        username: input.username === null
            ? null
            : (0, exports.parseUsername)(input.username, 'resolveCollectionUsernameResult.username'),
    };
};
exports.parseResolveCollectionUsernameResult = parseResolveCollectionUsernameResult;
